webpackJsonp([1,2],Array(47).concat([
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatch__ = __webpack_require__(252);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });



var api = new __WEBPACK_IMPORTED_MODULE_0__classes__["a" /* Connection */]({
  endpoint: 'https://spk-blog.prismic.io/api',
  queryPath: '/documents/search',
  dispatch: __WEBPACK_IMPORTED_MODULE_1__dispatch__["a" /* default */]
});



/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony export (immutable) */ __webpack_exports__["b"] = getElapsedTime;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDateTime;

function getElapsedTime(_ref) {
  var since = _ref.date,
      _ref$lang = _ref.lang,
      lang = _ref$lang === undefined ? 'en' : _ref$lang;

  var minutes = (new Date() - since) / 60000;

  var units = {
    year: { en: 'year', fr: 'an' },
    day: { en: 'day', fr: 'jour' },
    hour: { en: 'hour', fr: 'heure' },
    minute: { en: 'minute', fr: 'minute' }
  };

  lang = !units.year[lang] ? 'en' : lang;

  var _ref2 = minutes / 1440 > 365 ? [minutes / 525600 | 0, units.year[lang]] : minutes >= 1440 ? [minutes / 1440 | 0, units.day[lang]] : minutes >= 60 ? [minutes / 60 | 0, units.hour[lang]] : minutes > 1 ? [minutes | 0, units.minute[lang]] : [1, units.minute[lang]],
      _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
      time = _ref3[0],
      unit = _ref3[1];

  unit = time > 1 ? unit + 's' : unit;

  return time + ' ' + unit;
}

function getDateTime(_ref4) {
  var dt = _ref4.date,
      _ref4$template = _ref4.template,
      template = _ref4$template === undefined ? '$d/$m/$y $h:$t' : _ref4$template,
      _ref4$lang = _ref4.lang,
      lang = _ref4$lang === undefined ? 'en' : _ref4$lang;

  var months = {
    en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    fr: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
  };

  var d = { y: dt.getFullYear(), m: dt.getMonth(), d: dt.getDate() };
  var t = { h: dt.getHours(), m: dt.getMinutes() };
  var pf = !~template.indexOf('$h') ? '' : t.h > 12 ? 'PM' : 'AM';

  return template.replace(/\$y/g, ('' + d.y).substring(2, 4)).replace(/\$Y/g, d.y).replace(/\$mm/g, d.m + 1 > 9 ? d.m + 1 : '0' + (d.m + 1)).replace(/\$m/g, d.m + 1).replace(/\$M/g, months[lang][d.m]).replace(/(\$dd|\$DD)/g, d.d > 9 ? d.d : '0' + d.d).replace(/(\$d|\$D)/g, d.d).replace(/\$h/g, t.h > 12 ? t.h - 12 : !t.h ? t.h + 12 : t.h).replace(/\$H/g, t.h).replace(/(\$t|\$T)/g, t.m > 9 ? t.m : '0' + t.m) + pf;
}

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  beforeMount: function beforeMount() {
    this.updateMeta();
  },


  computed: {
    metaData: function metaData() {
      return {
        title: this.content.metatitle,
        description: this.content.metadesc,
        openGraph: {
          image: this.content.ogimage ? this.content.ogimage.crops.facebook : null
        }
      };
    }
  },

  methods: {
    updateMeta: function updateMeta() {
      this.$meta.tags = this.metaData;
    }
  }
};

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__init_state__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutations__ = __webpack_require__(268);




var _mutations;







var strict = "production" !== 'production';

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vuex___default.a);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_4_vuex___default.a.Store({
  state: __WEBPACK_IMPORTED_MODULE_6__init_state__["a" /* default */],
  strict: strict,
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["a" /* moves */].INCREMENT, function (state) {
    state.moves++;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["b" /* vector */].INITIALIZE, function (state) {
    state.vector.initialized = true;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["c" /* authors */].ADD, function (state, author) {
    __WEBPACK_IMPORTED_MODULE_3_vue___default.a.set(state.authors, author.uid, author);
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["d" /* events */].SET, function (state, events) {
    state.events = events;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["d" /* events */].SET_FEATURED, function (state, featuredEvent) {
    state.events.featured = featuredEvent;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["e" /* content */].SET, function (state, _ref) {
    var view = _ref.view,
        data = _ref.data;

    __WEBPACK_IMPORTED_MODULE_3_vue___default.a.set(state.content, view, data);
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["e" /* content */].READY, function (state, view) {
    state.content.ready = true;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["f" /* posts */].SET_OFFSET, function (state, id) {
    state.posts.offset = id;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["f" /* posts */].SET_TOTAL, function (state, total) {
    state.posts.total = total;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["f" /* posts */].CACHE, function (state, post) {
    __WEBPACK_IMPORTED_MODULE_3_vue___default.a.set(state.posts.cache, post.path, post);
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["f" /* posts */].SET_OFFSET_FEATURED, function (state, offsetFeatured) {
    state.posts.offsetFeatured = offsetFeatured;
  }), _mutations),

  actions: {
    onLoad: function onLoad(_ref2) {
      var commit = _ref2.commit;

      __WEBPACK_IMPORTED_MODULE_5_src_api__["a" /* default */].connect().then(function (ref) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_5_src_api__["a" /* default */].dispatch.fetchOnLoad(['blog', 'home', 'calendar', 'ecosystem', 'meta']), __WEBPACK_IMPORTED_MODULE_5_src_api__["a" /* default */].dispatch.fetchPostCount()]).then(function (_ref3) {
          var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
              results = _ref4[0],
              total = _ref4[1];

          results.forEach(function (_ref5) {
            var view = _ref5.view,
                data = _ref5.data;

            commit('content/SET', { view: view, data: data });
          });

          commit('posts/SET_TOTAL', total);
          commit('content/READY');
        });
      });
    },
    fetchAuthors: function fetchAuthors(_ref6) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_5_src_api__["a" /* default */].dispatch.fetchAuthors().then(function (results) {
        results.forEach(function (author) {
          commit('authors/ADD', author);
        });
      });
    }
  },

  getters: {
    findPost: function findPost(state) {
      return function (path) {
        return state.posts.cache[path] || false;
      };
    },
    findEvent: function findEvent(state) {
      return function (path) {
        return state.events.cache[path] || false;
      };
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTMLContent; });




var HTMLContent = function () {
  function HTMLContent(_ref) {
    var component = _ref.component,
        content = _ref.content,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["component", "content"]);

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, HTMLContent);

    this.component = component;
    this.content = content;
    this.props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(HTMLContent, [{
    key: "extend",
    value: function extend(props) {
      this.props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, props);
    }
  }, {
    key: "reduce",
    value: function reduce() {
      return {
        component: this.component,
        content: this.content,
        props: this.props
      };
    }
  }]);

  return HTMLContent;
}();

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var _sort = {
  published: function published(_ref) {
    var ascending = _ref.ascending;
    return 'document.first_publication_date' + (ascending ? '' : ' desc');
  },
  updated: function updated(_ref2) {
    var ascending = _ref2.ascending;
    return 'document.last_publication_date' + (ascending ? '' : ' desc');
  },
  field: function field(_ref3) {
    var type = _ref3.type,
        _field = _ref3.field,
        ascending = _ref3.ascending;
    return 'my.' + type + '.' + _field + (ascending ? '' : ' desc');
  }
};

/* harmony default export */ __webpack_exports__["a"] = function () {
  for (var _len = arguments.length, queries = Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }

  return {
    q: '[' + queries.join(' ') + ']',
    sort: function sort() {
      for (var _len2 = arguments.length, sorts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        sorts[_key2] = arguments[_key2];
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        orderings: '[' + sorts.map(function (order) {
          return _sort[order.by](order);
        }).join(', ') + ']'
      }, this);
    },
    reduce: function reduce() {
      delete this.sort;
      delete this.reduce;
      return this;
    }
  };
};

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var queryString = function queryString(directive) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return '[:d = ' + directive + '(' + args.join(', ') + ')]';
};

/* harmony default export */ __webpack_exports__["a"] = {
  has: function has(type, field) {
    return queryString('has', 'my.' + type + '.' + field);
  },
  missing: function missing(type, field) {
    return queryString('missing', 'my.' + type + '.' + field);
  },
  similar: function similar(id, precision) {
    return queryString('similar', '"' + id + '"', precision);
  },
  at: {
    id: function id(_id) {
      return queryString('at', 'document.id', '"' + _id + '"');
    },
    uid: function uid(type, _uid) {
      return queryString('at', 'my.' + type + '.uid', '"' + _uid + '"');
    },
    type: function type(_type) {
      return queryString('at', 'document.type', '"' + _type + '"');
    },
    tags: function tags(_tags) {
      return queryString('at', 'document.tags', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_tags));
    },
    field: function field(type, _field, value) {
      return queryString('at', 'my.' + type + '.' + _field, '"' + value + '"');
    }
  },

  in: {
    id: function id(ids) {
      return queryString('in', 'document.id', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ids));
    },
    uid: function uid(type, uids) {
      return queryString('in', 'my.' + type + '.uid', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(uids));
    }
  },

  any: {
    id: function id(ids) {
      return queryString('any', 'document.id', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ids));
    },
    uid: function uid(type, uids) {
      return queryString('any', 'my.' + type + '.uid', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(uids));
    },
    type: function type(types) {
      return queryString('any', 'document.type', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(types));
    },
    tags: function tags(_tags2) {
      return queryString('any', 'document.tags', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_tags2));
    },
    field: function field(type, _field2, values) {
      return queryString('any', 'my.' + type + '.' + _field2, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(values));
    }
  },

  not: {
    id: function id(_id2) {
      return queryString('not', 'document.id', '"' + _id2 + '"');
    },
    uid: function uid(type, _uid2) {
      return queryString('not', 'my.' + type + '.uid', '"' + _uid2 + '"');
    },
    type: function type(_type2) {
      return queryString('not', 'document.type', '"' + _type2 + '"');
    },
    tags: function tags(tag) {
      return queryString('not', 'document.tags', '"' + tag + '"');
    },
    field: function field(type, _field3, value) {
      return queryString('not', 'my.' + type + '.' + _field3, '"' + value + '"');
    }
  },

  search: {
    doc: function doc(search) {
      return queryString('fulltext', 'document', '"' + search.join(' ') + '"');
    },
    field: function field(type, _field4, search) {
      return queryString('fulltext', 'my.' + type + '.' + _field4, '"' + search.join(' ') + '"');
    }
  },

  date: {
    before: function before(type, field, date) {
      return queryString('date.before', 'my.' + type + '.' + field, date.valueOf());
    },
    after: function after(type, field, date) {
      return queryString('date.after', 'my.' + type + '.' + field, date.valueOf());
    },
    between: function between(type, field, start, end) {
      return queryString('date.between', 'my.' + type + '.' + field, start.valueOf(), end.valueOf());
    },
    published: {
      before: function before(date) {
        return queryString('date.before', 'document.first_publication_date', date.valueOf());
      },
      after: function after(date) {
        return queryString('date.after', 'document.first_publication_date', date.valueOf());
      },
      between: function between(start, end) {
        return queryString('date.between', 'document.first_publication_date', start.valueOf(), end.valueOf());
      }
    }
  }
};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes__ = __webpack_require__(166);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reduce; });



var _type;





var reduce = {
  content: function content(_content) {
    var reduced = {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_content).forEach(function (prop) {
      reduced[prop] = reduce.type[_content[prop].type](_content[prop]);
    });

    return reduced;
  },

  type: (_type = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_type, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* GROUP */], function (_ref) {
    var value = _ref.value;

    return value.map(reduce.content);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_type, __WEBPACK_IMPORTED_MODULE_2__types__["b" /* TEXT */], function (_ref2) {
    var value = _ref2.value;

    return value;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_type, __WEBPACK_IMPORTED_MODULE_2__types__["c" /* SELECT */], function (_ref3) {
    var value = _ref3.value;

    return value;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_type, __WEBPACK_IMPORTED_MODULE_2__types__["d" /* LINK */], function (_ref4) {
    var value = _ref4.value;

    return value.url;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_type, __WEBPACK_IMPORTED_MODULE_2__types__["e" /* PATH */], function (_ref5) {
    var value = _ref5.value;

    return value.document.uid || value.document.id;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_type, __WEBPACK_IMPORTED_MODULE_2__types__["f" /* DATETIME */], function (_ref6) {
    var value = _ref6.value;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* parseDateString */])(value);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_type, __WEBPACK_IMPORTED_MODULE_2__types__["g" /* IMAGE */], function (_ref7) {
    var value = _ref7.value;
    var _value$main = value.main,
        url = _value$main.url,
        alt = _value$main.alt;

    var crops = {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(value.views).forEach(function (crop) {
      crops[crop] = value.views[crop].url;
    });

    return { url: url, alt: alt, crops: crops };
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_type, __WEBPACK_IMPORTED_MODULE_2__types__["h" /* RTE */], function (_ref8) {
    var value = _ref8.value;

    var list = null;
    var elements = [];
    var next = 0;

    value.forEach(function (content) {
      next++;
      switch (true) {
        case /image/.test(content.type):
          var img = new __WEBPACK_IMPORTED_MODULE_4__classes__["b" /* Image */]({ component: 'content-image', content: content });
          elements.push(img.parse().reduce());
          break;

        case /paragraph/.test(content.type):
          var p = new __WEBPACK_IMPORTED_MODULE_4__classes__["c" /* RichText */]({ component: 'content-text', tag: 'p', content: content });
          elements.push(p.parse().reduce());
          break;

        case /heading/.test(content.type):
          var level = content.type.match(/\d/)[0];
          var h = new __WEBPACK_IMPORTED_MODULE_4__classes__["c" /* RichText */]({ component: 'content-text', tag: 'h' + level, content: content });
          elements.push(h.parse().reduce());
          break;

        case /list-item/.test(content.type):
          if (!list) {
            list = new __WEBPACK_IMPORTED_MODULE_4__classes__["d" /* ListItems */]({ component: 'content-list', content: [] });
          }

          list.add(content);

          if (next === value.length || value[next].type !== 'list-item') {
            elements.push(list.reduce());
            list = null;
          }

          break;

        default:
          console.error('Could not parse content:', content);
      }
    });

    return elements;
  }), _type)
};



/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipText;
function clipText(text, maxChars) {
  var count = 0;
  var clipped = [];

  if (text.length <= maxChars) {
    return text;
  }

  text.split(' ').some(function (word) {
    count += word.length + 1;

    if (count <= maxChars) {
      clipped.push(word);
    }

    return count > maxChars;
  });

  return clipped.join(' ').replace(/[,.!?]$/, '') + '...';
}

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */,
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HTMLContent__ = __webpack_require__(110);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RichText; });







var RichText = function (_HTMLContent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RichText, _HTMLContent);

  function RichText() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RichText);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RichText.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RichText)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RichText, [{
    key: 'parse',
    value: function parse() {
      var _this2 = this;

      var spans = this.content.spans;
      var text = this.content.text.split('');

      this.last = null;

      spans.forEach(function (_ref, i) {
        var start = _ref.start,
            end = _ref.end,
            type = _ref.type,
            data = _ref.data;

        var tag = _this2.getTags(type, data);
        var offset = _this2.getOffset(i, start, end);

        if (tag) {
          text.splice(start + offset.open, 0, tag.open);
          text.splice(end + offset.close, 0, tag.close);
        }
      });

      this.content = text.join('');
      return this;
    }
  }, {
    key: 'getOffset',
    value: function getOffset(index, start, end) {
      var offset = index * 2;
      var nested = this.last > start;

      this.last = end;
      return {
        open: nested ? offset - 1 : offset,
        close: nested ? offset : ++offset
      };
    }
  }, {
    key: 'getTags',
    value: function getTags(type, data) {
      var T_ = {
        em: function em() {
          return { open: '<em>', close: '</em>' };
        },
        strong: function strong() {
          return { open: '<strong>', close: '</strong>' };
        },
        hyperlink: function hyperlink(_ref2) {
          var value = _ref2.value;
          return { open: '<a href="' + value.url + '" target="_blank">', close: '</a>' };
        }
      };

      var tags = !T_[type] ? false : T_[type](data);

      return tags;
    }
  }]);

  return RichText;
}(__WEBPACK_IMPORTED_MODULE_5__HTMLContent__["a" /* HTMLContent */]);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Connection__ = __webpack_require__(249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Connection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RichText__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__RichText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListItems__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__ListItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Image__ = __webpack_require__(250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Image__["a"]; });





/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseDateString;

function parseDateString(dateString) {
  var formats = [{
    valid: /^\d{4}(?:-\d\d){2}T(?:\d\d:){2}\d\d(?:\.\d{3}Z?|\+\d\d:\d\d)?$/,
    find: /(.+)/,
    sub: '$1'
  }, {
    valid: /^\d{4}(?:-\d\d){2}T(?:\d\d:){2}\d\d\+\d{4}$/,
    find: /^(\d{4}(?:-\d\d){2}T(?:\d\d:){2}\d\d\+\d\d)(\d\d)$/,
    sub: '$1:$2'
  }, {
    valid: /^\d{4}(?:-\d\d){2}T(?:\d\d:){2}\d\d.+$/,
    find: /(^\d{4}(?:-\d\d){2}T(?:\d\d:){2}\d\d).+$/,
    sub: '$1'
  }];

  var validDate = formats.some(function (format) {
    var valid = format.valid.test(dateString);

    if (valid) {
      dateString = dateString.replace(format.find, format.sub);
    }

    return valid;
  });

  return !validDate ? new Date() : new Date(dateString);
}

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Icon__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SpkLogo__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SpkLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SpkLogo__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__SpkLogo___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SvgSymbols__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SvgSymbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SvgSymbols__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__SvgSymbols___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BackgroundVector__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BackgroundVector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BackgroundVector__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__BackgroundVector___default.a; });





/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blog__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Blog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Blog___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFeed__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BlogFeed__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__BlogFeed___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogPost__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogPost___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BlogPost__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__BlogPost___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PostGrid__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PostGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PostGrid__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__PostGrid___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PostPreview__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PostPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PostPreview__);
/* unused harmony reexport PostPreview */






/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contact__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Contact__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Contact___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Authors__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Authors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Authors__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Authors___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotFound__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NotFound__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__NotFound___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewsletterForm__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewsletterForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NewsletterForm__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__NewsletterForm___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewsletterPanel__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewsletterPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NewsletterPanel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NewsletterPanel___default.a; });






/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__(257);




/* harmony default export */ __webpack_exports__["a"] = {
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2__globals__).map(function (component) {
    return __WEBPACK_IMPORTED_MODULE_2__globals__[component];
  }),
  register: function register() {
    this.components.forEach(function (global) {
      __WEBPACK_IMPORTED_MODULE_1_vue___default.a.component(global.name, global);
    });
  }
};

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DocumentMetaMap__ = __webpack_require__(262);


/* harmony default export */ __webpack_exports__["a"] = {
  install: function install(Vue) {
    Vue.prototype.$meta = new __WEBPACK_IMPORTED_MODULE_0__DocumentMetaMap__["a" /* DocumentMetaMap */]();
  }
};

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_MediaSynchronizer__ = __webpack_require__(264);


/* harmony default export */ __webpack_exports__["a"] = {
  install: function install(Vue, queries) {
    var sync = new __WEBPACK_IMPORTED_MODULE_0__classes_MediaSynchronizer__["a" /* MediaSynchronizer */](Vue, queries);
    Vue.prototype.$media = sync.media;
  }
};

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index_routes__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ga__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_ga__);






__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index_routes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router___default.a({
  mode: 'history',
  linkActiveClass: 'active',
  routes: __WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_4_vue_ga___default()(router, 'UA-97864362-1');

/* harmony default export */ __webpack_exports__["a"] = router;

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pace_progress__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pace_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pace_progress__);


/* harmony default export */ __webpack_exports__["a"] = {
  run: function run() {
    __WEBPACK_IMPORTED_MODULE_0_pace_progress___default.a.start();

    __WEBPACK_IMPORTED_MODULE_0_pace_progress___default.a.once('hide', function () {
      window.prerenderReady = true;
    });

    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }

    console.info('%c', 'line-height:24px;padding:12px 150px;background:url(\'https://www.spk.rocks/static/svg/production-spektrum.svg\') center / contain no-repeat;');

    Math.ceil = function (n) {
      return ~~n + ~~!!(n % 1);
    };
  }
};

/***/ }),
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */,
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_reducers__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_directives__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_store__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__query__ = __webpack_require__(111);









/* harmony default export */ __webpack_exports__["a"] = function ($api) {
  return {
    fetchAllEvents: function fetchAllEvents(featuredId) {
      var sort = { by: 'field', type: 'event', field: 'date', ascending: true };

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([$api.get({
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__utils_directives__["a" /* default */].at.id(featuredId))
      }), $api.get({
        pageSize: 100,
        page: 1,
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__utils_directives__["a" /* default */].at.type('event'), __WEBPACK_IMPORTED_MODULE_5__utils_directives__["a" /* default */].not.id(featuredId)).sort(sort)
      })]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            featured = _ref2[0].results,
            _ref2$ = _ref2[1],
            feed = _ref2$.results,
            pages = _ref2$.total_pages;

        if (!featured.length || !feed.length) return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject();
        var _featured$ = featured[0],
            id = _featured$.id,
            data = _featured$.data,
            type = _featured$.type;


        var res = {
          feed: { active: [], inactive: [] },
          featured: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, __WEBPACK_IMPORTED_MODULE_4__utils_reducers__["a" /* default */].content(data[type]))
        };

        feed.forEach(function (_ref3) {
          var id = _ref3.id,
              data = _ref3.data,
              type = _ref3.type;

          var evt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, __WEBPACK_IMPORTED_MODULE_4__utils_reducers__["a" /* default */].content(data[type]));
          if (evt.date.valueOf() + 24 * 60 * 60 * 1000 < Date.now()) return res.feed.inactive.unshift(evt);
          res.feed.active.push(evt);
        });

        if (pages <= 1) {
          __WEBPACK_IMPORTED_MODULE_6_src_store__["a" /* default */].commit('events/SET', res);
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(res);
        }

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(--pages).keys())).map(function (i) {
          return $api.get({
            pageSize: 100,
            page: i + 2,
            query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__utils_directives__["a" /* default */].at.type('event'), __WEBPACK_IMPORTED_MODULE_5__utils_directives__["a" /* default */].not.id(featuredId)).sort(sort)
          });
        })).then(function (pages) {
          pages.forEach(function (page) {
            page.forEach(function (_ref4) {
              var id = _ref4.id,
                  data = _ref4.data,
                  type = _ref4.type;

              var evt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, __WEBPACK_IMPORTED_MODULE_4__utils_reducers__["a" /* default */].content(data[type]));
              if (evt.date.valueOf() + 24 * 60 * 60 * 1000 < Date.now()) return res.feed.inactive.unshift(evt);
              res.feed.active.push(evt);
            });
          });

          __WEBPACK_IMPORTED_MODULE_6_src_store__["a" /* default */].commit('events/SET', res);
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(res);
        });
      });
    }
  };
};

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_reducers__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_directives__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__query__ = __webpack_require__(111);






/* harmony default export */ __webpack_exports__["a"] = function ($api) {
  return {
    fetchOnLoad: function fetchOnLoad(types) {
      return $api.get({
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__utils_directives__["a" /* default */].any.type(types)),
        pageSize: types.length
      }).then(function (_ref) {
        var results = _ref.results;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(results.map(function (_ref2) {
          var type = _ref2.type,
              data = _ref2.data;
          return { view: type, data: __WEBPACK_IMPORTED_MODULE_2__utils_reducers__["a" /* default */].content(data[type]) };
        }));
      });
    },
    fetchAuthors: function fetchAuthors() {
      return $api.get({
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__utils_directives__["a" /* default */].at.type('author')),
        pageSize: 100
      }).then(function (_ref3) {
        var results = _ref3.results;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(results.map(function (result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            id: result.id,
            uid: result.uid
          }, __WEBPACK_IMPORTED_MODULE_2__utils_reducers__["a" /* default */].content(result.data[result.type]));
        }));
      });
    }
  };
};

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general__ = __webpack_require__(246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "general", function() { return __WEBPACK_IMPORTED_MODULE_0__general__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__posts__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "posts", function() { return __WEBPACK_IMPORTED_MODULE_1__posts__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "events", function() { return __WEBPACK_IMPORTED_MODULE_2__events__["a"]; });




/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_reducers__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_directives__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_store__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__query__ = __webpack_require__(111);








/* harmony default export */ __webpack_exports__["a"] = function ($api) {
  return {
    fetchPostCount: function fetchPostCount() {
      return $api.get({
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].at.type('post')),
        fetch: 'document.id'
      }).then(function (_ref) {
        var total = _ref.total_results_size;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(parseInt(total));
      });
    },
    fetchPost: function fetchPost(uid) {
      var cached = __WEBPACK_IMPORTED_MODULE_5_src_store__["a" /* default */].getters.findPost(uid);
      if (cached) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(cached);
      }

      return $api.get({
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].at.uid('post', uid)),
        pageSize: 1
      }).then(function (_ref2) {
        var results = _ref2.results;

        var post = void 0;
        if (!results.length) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject();
        }

        post = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          id: results[0].id,
          path: uid,
          firstPublished: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["a" /* parseDateString */])(results[0].first_publication_date)
        }, __WEBPACK_IMPORTED_MODULE_3__utils_reducers__["a" /* default */].content(results[0].data.post));

        __WEBPACK_IMPORTED_MODULE_5_src_store__["a" /* default */].commit('posts/CACHE', post);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(post);
      });
    },
    fetchPostCollection: function fetchPostCollection(uids) {
      uids = uids.length > 4 ? uids.slice(0, 5) : uids;
      return $api.get({
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].in.uid('post', uids))
      }).then(function (_ref3) {
        var results = _ref3.results;

        if (!results.length) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(null);

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({
          posts: results.map(function (result) {
            var post = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              id: result.id,
              path: result.uid,
              firstPublished: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["a" /* parseDateString */])(result.first_publication_date)
            }, __WEBPACK_IMPORTED_MODULE_3__utils_reducers__["a" /* default */].content(result.data[result.type]));

            __WEBPACK_IMPORTED_MODULE_5_src_store__["a" /* default */].commit('posts/CACHE', post);
            return post;
          })
        });
      });
    },
    fetchPostId: function fetchPostId(index, filter) {
      var featured = false;
      var fetchId = function fetchId() {
        var query = !featured ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].at.type('post')) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].at.type('post'), __WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].not.uid('post', filter));

        return $api.get({
          query: query.sort({ by: 'field', type: 'post', field: 'published' }),
          fetch: 'post.id',
          pageSize: index + 1
        }).then(function (_ref4) {
          var results = _ref4.results;

          if (!results.length || !results[index]) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject();
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ id: results[index].id, featured: featured });
        });
      };

      if (filter) {
        return $api.get({
          query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].at.type('post')).sort({ by: 'field', type: 'post', field: 'published' }),
          fetch: 'post.id',
          pageSize: index + 1
        }).then(function (_ref5) {
          var results = _ref5.results;

          if (!results.length || !results[index]) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject();
          featured = results.some(function (result) {
            return result.uid === filter;
          });

          if (featured) return fetchId();
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ id: results[index].id, featured: featured });
        });
      } else {
        return fetchId();
      }
    },
    fetchPostFeed: function fetchPostFeed(_ref6) {
      var page = _ref6.page,
          pageSize = _ref6.pageSize,
          after = _ref6.after,
          category = _ref6.category,
          filter = _ref6.filter;

      var query = filter ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].missing('post', 'preview-mode'), __WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].not.uid('post', filter)) : category ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].missing('post', 'preview-mode'), __WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].at.field('post', 'category', category)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].missing('post', 'preview-mode'));

      return $api.get({
        query: query.sort({ by: 'field', type: 'post', field: 'published' }),
        pageSize: pageSize,
        after: after,
        page: page
      }).then(function (_ref7) {
        var page = _ref7.page,
            results = _ref7.results,
            pages = _ref7.total_pages;

        if (!results.length) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject();

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({
          page: page,
          pages: pages,
          posts: results.map(function (result) {
            var post = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              id: result.id,
              path: result.uid,
              firstPublished: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["a" /* parseDateString */])(result.first_publication_date)
            }, __WEBPACK_IMPORTED_MODULE_3__utils_reducers__["a" /* default */].content(result.data[result.type]));

            __WEBPACK_IMPORTED_MODULE_5_src_store__["a" /* default */].commit('posts/CACHE', post);
            return post;
          })
        });
      });
    },
    fetchSimilarPosts: function fetchSimilarPosts(id, precision) {
      return $api.get({
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].at.type('post'), __WEBPACK_IMPORTED_MODULE_4__utils_directives__["a" /* default */].similar(id, precision)),
        fetch: 'post.uid',
        pageSize: 3
      }).then(function (_ref8) {
        var results = _ref8.results;

        var result = results.map(function (result) {
          return result.uid;
        });
        if (results.length > 2 || __WEBPACK_IMPORTED_MODULE_5_src_store__["a" /* default */].state.posts.total <= 2) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);
        }

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result);
      });
    }
  };
};

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Connection; });







var Connection = function () {
  function Connection(_ref) {
    var endpoint = _ref.endpoint,
        queryPath = _ref.queryPath,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Connection);

    this.endpoint = endpoint;
    this.url = endpoint + queryPath;
    this.ref = null;
    this.dispatch = dispatch(this);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Connection, [{
    key: 'connect',
    value: function connect() {
      return this.getRef().then(function () {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      });
    }
  }, {
    key: 'get',
    value: function get(_ref2) {
      var _this = this;

      var query = _ref2.query,
          options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['query']);

      return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.http.get(this.url, {
        params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ ref: this.ref }, query.reduce(), options)
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.error) {
          console.info(data.error);
          return _this.getRef().then(function () {
            return _this.get(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ query: query }, options));
          });
        }

        if (options.pageSize && options.pageSize < data.results.length) {
          data.results = data.results.slice(0, options.pageSize);
        }

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(data);
      });
    }
  }, {
    key: 'getRef',
    value: function getRef() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_vue___default.a.http.get(this.endpoint).then(function (response) {
        return response.json();
      }).then(function (_ref3) {
        var refs = _ref3.refs;

        _this2.ref = refs.find(function (ref) {
          return ref.isMasterRef;
        }).ref;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      });
    }
  }]);

  return Connection;
}();

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HTMLContent__ = __webpack_require__(110);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });







var Image = function (_HTMLContent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Image, _HTMLContent);

  function Image() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Image);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Image.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Image)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Image, [{
    key: 'parse',
    value: function parse() {
      var _content = this.content,
          url = _content.url,
          alt = _content.alt,
          dimensions = _content.dimensions,
          caption = _content.copyright;

      this.content = { url: url, alt: alt, caption: caption, width: dimensions.width };

      return this;
    }
  }]);

  return Image;
}(__WEBPACK_IMPORTED_MODULE_5__HTMLContent__["a" /* HTMLContent */]);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HTMLContent__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RichText__ = __webpack_require__(165);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListItems; });








var ListItems = function (_HTMLContent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ListItems, _HTMLContent);

  function ListItems() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ListItems);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ListItems.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ListItems)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ListItems, [{
    key: 'add',
    value: function add(content) {
      this.content.push(new __WEBPACK_IMPORTED_MODULE_6__RichText__["a" /* RichText */]({ content: content }).parse().content);
    }
  }]);

  return ListItems;
}(__WEBPACK_IMPORTED_MODULE_5__HTMLContent__["a" /* HTMLContent */]);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(247);




/* harmony default export */ __webpack_exports__["a"] = function ($api) {
  var dispatchers = {};
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2__actions__).forEach(function (scope) {
    dispatchers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dispatchers, __WEBPACK_IMPORTED_MODULE_2__actions__[scope]($api));
  });

  return dispatchers;
};

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATETIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TEXT; });
var DATETIME = 'Timestamp';
var RTE = 'StructuredText';
var PATH = 'Link.document';
var SELECT = 'Select';
var LINK = 'Link.web';
var GROUP = 'Group';
var IMAGE = 'Image';
var TEXT = 'Text';

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Text__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Text__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Text___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__List__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__List___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Image__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Image___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wrapper__ = __webpack_require__(256);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__wrapper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__safe_link__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__safe_link__["a"]; });






/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  name: 'safe-link',
  render: function render(h) {
    var tag = this.url ? 'a' : 'span';
    var data = this.url ? { attrs: { href: this.url, target: '_blank' } } : {};
    return h(tag, data, this.$slots.default);
  },

  props: {
    url: String
  }
};

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  name: 'content-wrapper',
  render: function render(h) {
    return h(this.tag, this.$slots.default);
  },

  props: {
    tag: {
      type: String,
      required: true
    }
  }
};

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphics__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return __WEBPACK_IMPORTED_MODULE_0__graphics__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SpkLogo", function() { return __WEBPACK_IMPORTED_MODULE_0__graphics__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BackgroundVector", function() { return __WEBPACK_IMPORTED_MODULE_0__graphics__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation__ = __webpack_require__(261);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderNav", function() { return __WEBPACK_IMPORTED_MODULE_1__navigation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FooterNav", function() { return __WEBPACK_IMPORTED_MODULE_1__navigation__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonLink", function() { return __WEBPACK_IMPORTED_MODULE_1__navigation__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__content__ = __webpack_require__(254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return __WEBPACK_IMPORTED_MODULE_2__content__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_2__content__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return __WEBPACK_IMPORTED_MODULE_2__content__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Wrapper", function() { return __WEBPACK_IMPORTED_MODULE_2__content__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SafeLink", function() { return __WEBPACK_IMPORTED_MODULE_2__content__["e"]; });




/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ecosystem__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ecosystem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Ecosystem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Ecosystem___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntityDetails__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntityDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EntityDetails__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__EntityDetails___default.a; });



/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Events__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Events__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Events___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventCalendar__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EventCalendar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__EventCalendar___default.a; });



/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Home__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Home__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Home___default.a; });


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderNav__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HeaderNav__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__HeaderNav___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FooterNav__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FooterNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FooterNav__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__FooterNav___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ButtonLink__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ButtonLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ButtonLink__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__ButtonLink___default.a; });




/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OpenGraphMeta__ = __webpack_require__(263);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentMetaMap; });





var DocumentMetaMap = function () {
  function DocumentMetaMap() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DocumentMetaMap);

    this.canonical = document.head.querySelector('[rel="canonical"]');
    this.description = document.head.querySelector('[name="description"]');

    this.defaultValues = {
      url: null,
      title: null,
      image: null,
      siteName: null,
      description: null
    };

    this.openGraph = new __WEBPACK_IMPORTED_MODULE_3__OpenGraphMeta__["a" /* OpenGraphMeta */]({
      url: { property: 'url' },
      title: { property: 'title' },
      siteName: { property: 'site_name' },
      description: { property: 'description' },
      type: { property: 'type', content: 'website' },
      image: { property: 'image' },
      imageWidth: { property: 'image:width', content: 1200 },
      imageHeight: { property: 'image:height', content: 630 }
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DocumentMetaMap, [{
    key: 'defaults',
    set: function set(defaults) {
      var _this = this;

      defaults.url = defaults.url || window.location.origin;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.defaultValues).forEach(function (prop) {
        if (defaults[prop]) _this.defaultValues[prop] = defaults[prop];
      });
    }
  }, {
    key: 'tags',
    set: function set(_ref) {
      var title = _ref.title,
          description = _ref.description,
          _ref$openGraph = _ref.openGraph,
          openGraph = _ref$openGraph === undefined ? {} : _ref$openGraph;

      var url = this.defaultValues.url + window.location.pathname;
      document.title = title || this.defaultValues.title;
      this.canonical.setAttribute('href', url);
      this.description.setAttribute('content', description || this.defaultValues.description);

      openGraph.url = openGraph.url || url;
      openGraph.title = openGraph.title || title;
      openGraph.description = openGraph.description || description;

      this.openGraph.tags = {
        current: openGraph,
        defaults: this.defaultValues
      };
    }
  }]);

  return DocumentMetaMap;
}();

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenGraphMeta; });



var OpenGraphMeta = function () {
  function OpenGraphMeta(tags) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OpenGraphMeta);

    this.tagKeys = ['url', 'siteName', 'title', 'description', 'image'];
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tags).forEach(function (tag) {
      var meta = _this.createTag(tags[tag]);
      document.head.appendChild(meta);
      _this[tag] = meta;
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OpenGraphMeta, [{
    key: 'createTag',
    value: function createTag(_ref) {
      var property = _ref.property,
          _ref$content = _ref.content,
          content = _ref$content === undefined ? '' : _ref$content;

      var meta = document.createElement('meta');

      meta.setAttribute('property', 'og:' + property);
      meta.setAttribute('content', content);

      return meta;
    }
  }, {
    key: 'addTag',
    value: function addTag(tag) {
      var meta = void 0;
      if (!tag.name || !tag.property || this[tag.name]) return;

      meta = this.createTag(tag);
      document.head.appendChild(meta);
      this[tag.name] = meta;
    }
  }, {
    key: 'tags',
    set: function set(_ref2) {
      var _this2 = this;

      var defaults = _ref2.defaults,
          _ref2$current = _ref2.current,
          current = _ref2$current === undefined ? {} : _ref2$current;

      this.tagKeys.forEach(function (tag) {
        var content = current[tag] || defaults[tag];
        if (content) _this2[tag].setAttribute('content', content);
      });
    }
  }]);

  return OpenGraphMeta;
}();

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaSynchronizer; });




var MediaSynchronizer = function () {
  function MediaSynchronizer(Vue) {
    var queries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaSynchronizer);

    var data = {};
    var mqLists = void 0,
        viewWidth = void 0,
        operands = void 0,
        buffer = void 0,
        watcher = void 0;

    if (window.matchMedia) {
      mqLists = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(queries).forEach(function (media) {
        mqLists[media] = matchMedia('(' + queries[media] + ')');
        data[media] = mqLists[media].matches;

        mqLists[media].addListener(function (mq) {
          data[media] = mq.matches;
        });
      });
    } else {
      mqLists = [];
      watcher = this.createWatcher();
      viewWidth = watcher.clientWidth;
      operands = {
        max: '<',
        min: '>'
      };

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(queries).forEach(function (media) {
        var _queries$media$replac = queries[media].replace(/\s/g, '').match(/([^:-]+)(?:-[^:-]+)?:(\d+)/).filter(function (r, index) {
          return index;
        }),
            _queries$media$replac2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_queries$media$replac, 2),
            op = _queries$media$replac2[0],
            val = _queries$media$replac2[1];

        var query = operands[op] + val;
        mqLists.push({ media: media, query: query });

        data[media] = eval(viewWidth + query);
      });

      window.addEventListener('resize', function () {
        var ref = watcher.clientWidth;
        buffer = true;

        setTimeout(function () {
          if (watcher.clientWidth === ref && buffer) {
            buffer = false;
            mqLists.forEach(function (_ref) {
              var media = _ref.media,
                  query = _ref.query;

              data[media] = eval(ref + query);
            });
          }
        }, 100);
      });
    }

    this.syncVM = new Vue({ data: data });
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(MediaSynchronizer, [{
    key: 'createWatcher',
    value: function createWatcher() {
      var watcher = document.createElement('div');
      var style = document.createElement('style');

      style.innerHTML = '[data-vue-media-sync] {\n      width: 100%;\n      overflow: scroll;\n      position: absolute;\n      bottom: 100%;\n    }';

      document.head.appendChild(style);
      watcher.setAttributeNode(document.createAttribute('data-vue-media-sync'));
      document.body.insertBefore(watcher, document.body.children[0]);

      return watcher;
    }
  }, {
    key: 'media',
    get: function get() {
      return this.syncVM.$data;
    }
  }]);

  return MediaSynchronizer;
}();

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_layouts_home__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layouts_events__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_layouts_blog__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_layouts_ecosystem__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_layouts_generic__ = __webpack_require__(170);






/* harmony default export */ __webpack_exports__["a"] = [{
  path: '/',
  name: 'home',
  component: __WEBPACK_IMPORTED_MODULE_0_components_layouts_home__["a" /* default */],
  meta: { label: 'SPK' },
  children: [{
    path: 'collaborateurs',
    name: 'authors',
    component: __WEBPACK_IMPORTED_MODULE_4_components_layouts_generic__["a" /* Authors */]
  }, {
    path: 'contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_4_components_layouts_generic__["b" /* Contact */]
  }, {
    path: 'infolettre',
    name: 'newsletter',
    component: __WEBPACK_IMPORTED_MODULE_4_components_layouts_generic__["c" /* NewsletterPanel */]
  }]
}, {
  path: '/ecosysteme',
  name: 'ecosystem',
  component: __WEBPACK_IMPORTED_MODULE_3_components_layouts_ecosystem__["a" /* default */],
  meta: { label: 'Écosystème' },
  children: [{
    path: ':entity',
    name: 'ecosystem-entity',
    component: __WEBPACK_IMPORTED_MODULE_3_components_layouts_ecosystem__["b" /* EntityDetails */],
    props: true
  }]
}, {
  path: '/blogue',
  component: __WEBPACK_IMPORTED_MODULE_2_components_layouts_blog__["a" /* default */],
  meta: { label: 'Blogue' },
  children: [{
    path: '',
    name: 'blog',
    component: __WEBPACK_IMPORTED_MODULE_2_components_layouts_blog__["b" /* BlogFeed */]
  }, {
    path: 'page/:paging',
    name: 'blog-page',
    component: __WEBPACK_IMPORTED_MODULE_2_components_layouts_blog__["b" /* BlogFeed */],
    props: true
  }, {
    path: 'categorie/:cat',
    name: 'blog-category',
    component: __WEBPACK_IMPORTED_MODULE_2_components_layouts_blog__["b" /* BlogFeed */],
    props: true
  }, {
    path: 'categorie/:category/page/:paging',
    name: 'blog-category-page',
    component: __WEBPACK_IMPORTED_MODULE_2_components_layouts_blog__["b" /* BlogFeed */],
    props: true
  }, {
    path: ':uid',
    name: 'blog-post',
    components: { default: __WEBPACK_IMPORTED_MODULE_2_components_layouts_blog__["b" /* BlogFeed */], post: __WEBPACK_IMPORTED_MODULE_2_components_layouts_blog__["c" /* BlogPost */] },
    props: { default: true, post: true }
  }]
}, {
  path: '/evenements',
  component: __WEBPACK_IMPORTED_MODULE_1_components_layouts_events__["a" /* default */],
  meta: { label: 'Événements' },
  children: [{
    path: '',
    name: 'events',
    component: __WEBPACK_IMPORTED_MODULE_1_components_layouts_events__["b" /* EventCalendar */]
  }, {
    path: 'page/:paging',
    name: 'events-page',
    component: __WEBPACK_IMPORTED_MODULE_1_components_layouts_events__["b" /* EventCalendar */],
    props: true
  }]
}, {
  path: '*',
  name: 'not-found',
  component: __WEBPACK_IMPORTED_MODULE_4_components_layouts_generic__["d" /* NotFound */],
  meta: { hidden: true }
}];

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = indexRoutes;
function indexRoutes(scopedRoutes, scopedIndex) {
  scopedRoutes.forEach(function (route, index) {
    if (!route.meta) {
      route.meta = {};
    }

    route.meta.index = scopedIndex || scopedIndex === 0 ? scopedIndex : index;

    if (route.children) {
      indexRoutes(route.children, route.meta.index);
    }
  });
}

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  moves: 0,
  authors: {},
  vector: { initialized: false },
  events: { featured: null, feed: null },
  content: { ready: false, title: null, meta: {} },
  posts: { cache: {}, offset: null, offsetFeatured: null, total: null },
  categories: {
    culture: { name: 'culture', label: 'Culture' },
    geeks: { name: 'geeks', label: 'Aspirante geek' },
    initiatives: { name: 'initiatives', label: 'Initiatives' },
    marketing: { name: 'marketing', label: 'Marketing' },
    specimens: { name: 'specimens', label: 'Spécimens SPK' }
  }
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return authors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return events; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return posts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return vector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return moves; });
var content = {
  SET: 'content/SET',
  READY: 'content/READY'
};

var authors = {
  ADD: 'authors/ADD'
};

var events = {
  SET: 'events/SET'
};

var posts = {
  CACHE: 'posts/CACHE',
  SET_TOTAL: 'posts/SET_TOTAL',
  SET_OFFSET: 'posts/SET_OFFSET',
  SET_OFFSET_FEATURED: 'posts/SET_OFFSET_FEATURED'
};

var vector = {
  INITIALIZE: 'vector/INITIALIZE'
};

var moves = {
  INCREMENT: 'moves/INCREMENT'
};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'vue-disqus',
  props: {
    shortname: {
      type: String,
      required: true
    },
    identifier: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    remote_auth_s3: {
      type: String,
      required: false
    },
    api_key: {
      type: String,
      required: false
    },
    sso_config: {
      type: Object,
      required: false
    },
    language: {
      type: String,
      required: false
    }
  },
  mounted: function mounted() {
    if (window.DISQUS) {
      this.reset(window.DISQUS);
      return;
    }
    this.init();
  },

  methods: {
    reset: function reset(dsq) {
      var self = this;
      dsq.reset({
        reload: true,
        config: function config() {
          self.setBaseConfig(this);
        }
      });
    },
    init: function init() {
      var _this = this;

      var self = this;
      window.disqus_config = function () {
        self.setBaseConfig(this);
      };
      setTimeout(function () {
        var d = document,
            s = d.createElement('script');
        s.setAttribute('id', 'embed-disqus');
        s.setAttribute('data-timestamp', +new Date());
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//' + _this.shortname + '.disqus.com/embed.js';(d.head || d.body).appendChild(s);
      }, 0);
    },
    setBaseConfig: function setBaseConfig(disqusConfig) {
      var _this2 = this;

      disqusConfig.page.identifier = this.identifier || this.$route.path || window.location.pathname;
      disqusConfig.page.url = this.url || this.$el.baseURI;
      if (this.title) {
        disqusConfig.page.title = this.title;
      }
      if (this.remote_auth_s3) {
        disqusConfig.page.remote_auth_s3 = this.remote_auth_s3;
      }
      if (this.api_key) {
        disqusConfig.page.api_key = this.api_key;
      }
      if (this.sso_config) {
        disqusConfig.sso = this.sso_config;
      }
      if (this.language) {
        disqusConfig.language = this.language;
      }

      disqusConfig.callbacks.onReady = [function () {
        _this2.$emit('ready');
      }];
    }
  }
};

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_graphics__ = __webpack_require__(168);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: { SvgSymbols: __WEBPACK_IMPORTED_MODULE_1_components_graphics__["a" /* SvgSymbols */] },

  beforeMount: function beforeMount() {
    this.$store.dispatch('onLoad');
    this.viewIndex = this.$route.meta.index;
  },
  data: function data() {
    return {
      transition: 'slide--right',
      viewIndex: 0
    };
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    ready: function ready(state) {
      return state.content.ready;
    },
    title: function title(state) {
      return state.content.title;
    }
  }),

  watch: {
    ready: function ready() {
      var _$store$state$content = this.$store.state.content.meta,
          ogimage = _$store$state$content.ogimage,
          title = _$store$state$content.ogtitle,
          siteName = _$store$state$content.ogsitename,
          description = _$store$state$content.ogdescription;


      this.$meta.defaults = { title: title, siteName: siteName, description: description, image: ogimage.crops.facebook };
    },
    '$route': function $route(to, from) {
      var toIndex = to.meta.index;
      var fromIndex = from.meta.index;

      if (toIndex !== fromIndex) {
        this.transition = toIndex > fromIndex ? 'slide--left' : 'slide--right';
        this.viewIndex = toIndex;
      }

      if (from) {
        this.$store.commit('moves/INCREMENT');
      }
    },
    title: function title() {
      document.title = this.title;
    }
  }
};

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'content-image',
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      content: this.item.content
    };
  }
};

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'content-list',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'content-text',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap_TweenLite__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap_TweenLite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap_TweenLite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap_EasePack__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap_EasePack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gsap_EasePack__);









/* harmony default export */ __webpack_exports__["default"] = {
  name: 'background-vector',
  props: {
    alpha: Number,
    scale: Number,
    rotate: Number,
    viewbox: Object,
    animated: Boolean,
    hideImages: Boolean,
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  mounted: function mounted() {
    if (!this.animated) this.setPoints();else if (this.$store.state.vector.initialized) this.resumeAnimation();else setTimeout(this.initAnimation, 450);
  },
  data: function data() {
    return {
      anchor: [500, 950],
      offset: { x: 0, y: 0 },
      opacity: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0, h: 0, i: 0, j: 0, k: 0, l: 0, image: 0 },
      points: { a: [500, 950], b: [500, 950], c: [500, 950], d: [500, 950], e: [500, 950], f: [500, 950], g: [500, 950], h: [500, 950], i: [500, 950], j: [500, 950], k: [500, 950], l: [500, 950] },
      references: {
        opacity: { a: 0.3, b: 0.2, c: 0.1, d: 0.1, e: 0.2, f: 0.15, g: 0.3, h: 0.2, i: 0.25, j: 0.15, k: 0.1, l: 0.3, image: 1 },
        points: { a: [150, 860], b: [180, 450], c: [390, 480], d: [240, 350], e: [550, 350], f: [400, 270], g: [1180, 600], h: [1030, 810], i: [775, 225], j: [650, 200], k: [1090, 50], l: [1350, 480] },
        viewbox: [-125, -125, 1750, 1250]
      }
    };
  },


  computed: {
    pathA: function pathA() {
      return 'M' + [this.anchor, this.points.a, this.points.b] + 'z';
    },
    pathB: function pathB() {
      return 'M' + [this.anchor, this.points.b, this.points.c] + 'z';
    },
    pathC: function pathC() {
      return 'M' + [this.points.b, this.points.c, this.points.d] + 'z';
    },
    pathD: function pathD() {
      return 'M' + [this.anchor, this.points.c, this.points.e] + 'z';
    },
    pathE: function pathE() {
      return 'M' + [this.points.c, this.points.e, this.points.f] + 'z';
    },
    pathF: function pathF() {
      return 'M' + [this.anchor, this.points.e, this.points.g] + 'z';
    },
    pathG: function pathG() {
      return 'M' + [this.anchor, this.points.g, this.points.h] + 'z';
    },
    pathH: function pathH() {
      return 'M' + [this.points.e, this.points.g, this.points.i] + 'z';
    },
    pathI: function pathI() {
      return 'M' + [this.points.e, this.points.i, this.points.j] + 'z';
    },
    pathJ: function pathJ() {
      return 'M' + [this.points.e, this.points.j, this.points.f] + 'z';
    },
    pathK: function pathK() {
      return 'M' + [this.points.i, this.points.g, this.points.k] + 'z';
    },
    pathL: function pathL() {
      return 'M' + [this.points.g, this.points.k, this.points.l] + 'z';
    },
    mobileImages: function mobileImages() {
      return this.$media.phone;
    },
    rebase: function rebase() {
      return {
        cX: window.innerWidth * 0.5,
        cY: window.innerHeight * 0.5
      };
    },
    classes: function classes() {
      return {
        'vector--static': !this.animated
      };
    },
    transforms: function transforms() {
      return [this.rotate ? 'rotate(' + this.rotate + ' 750 500)' : '', this.scale ? 'scale(' + this.scale + ')' : ''].join(' ');
    }
  },

  methods: {
    routeImage: function routeImage(path) {
      this.$router.push('/ecosysteme/' + path);
    },
    setViewbox: function setViewbox() {
      if (!this.viewbox) {
        return this.references.viewbox;
      } else {
        var vbox = this.viewbox;

        var _references$viewbox = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(this.references.viewbox, 4),
            offX = _references$viewbox[0],
            offY = _references$viewbox[1],
            sizeX = _references$viewbox[2],
            sizeY = _references$viewbox[3];

        return [vbox.offsetX || offX, vbox.offsetY || offY, vbox.sizeX || sizeX, vbox.sizeY || sizeY];
      }
    },
    setPoints: function setPoints() {
      this.opacity = this.references.opacity;
      this.points = this.references.points;
      this.$emit('vector-ready');
    },
    resumeAnimation: function resumeAnimation() {
      var _this = this;

      this.setPoints();

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.points).forEach(function (key) {
        _this.setAnimation(key, _this.references.points[key]);
      });
    },
    initAnimation: function initAnimation() {
      var _this2 = this;

      var delay = 0;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.points);
      this.$store.commit('vector/INITIALIZE');

      var _loop = function _loop() {
        var _TweenLite$to;

        var ref = _this2.references.points[keys[0]];
        var refs = {};

        keys.forEach(function (key) {
          refs[key] = ref;
        });

        var key = keys.shift();
        __WEBPACK_IMPORTED_MODULE_4_gsap_TweenLite___default.a.to(_this2.points, 0.8, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          ease: __WEBPACK_IMPORTED_MODULE_5_gsap_EasePack___default.a.easeOut,
          delay: delay * 0.2
        }, refs));

        __WEBPACK_IMPORTED_MODULE_4_gsap_TweenLite___default.a.to(_this2.opacity, 1, (_TweenLite$to = {
          ease: __WEBPACK_IMPORTED_MODULE_5_gsap_EasePack___default.a.easeOut,
          delay: delay * 0.2
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TweenLite$to, key, _this2.references.opacity[key]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TweenLite$to, 'onComplete', _this2.setAnimation), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TweenLite$to, 'onCompleteParams', [key, ref]), _TweenLite$to));

        delay++;
      };

      while (keys.length) {
        _loop();
      }

      setTimeout(function () {
        _this2.$emit('vector-ready');

        __WEBPACK_IMPORTED_MODULE_4_gsap_TweenLite___default.a.to(_this2.opacity, 0.8, {
          ease: __WEBPACK_IMPORTED_MODULE_5_gsap_EasePack___default.a.easeOut,
          delay: 0.5,
          image: 1
        });
      }, delay * 200 + 300);
    },
    setAnimation: function setAnimation(key, ref) {
      var _generateRandom = this.generateRandom(ref),
          duration = _generateRandom.duration,
          dest = _generateRandom.dest;

      this.animatePoint({ key: key, ref: ref, dest: dest, duration: duration });
    },
    animatePoint: function animatePoint(_ref) {
      var _TweenLite$to2;

      var key = _ref.key,
          ref = _ref.ref,
          duration = _ref.duration,
          dest = _ref.dest,
          _ref$delay = _ref.delay,
          delay = _ref$delay === undefined ? 0 : _ref$delay;

      __WEBPACK_IMPORTED_MODULE_4_gsap_TweenLite___default.a.to(this.points, duration, (_TweenLite$to2 = {
        delay: delay
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TweenLite$to2, key, dest), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TweenLite$to2, 'ease', __WEBPACK_IMPORTED_MODULE_5_gsap_EasePack___default.a.easeOut), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TweenLite$to2, 'onComplete', this.setAnimation), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TweenLite$to2, 'onCompleteParams', [key, ref]), _TweenLite$to2));
    },
    generateRandom: function generateRandom(_ref2) {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
          x = _ref3[0],
          y = _ref3[1];

      var minX = x - 25,
          minY = y - 25;

      return {
        duration: parseFloat((Math.random() + 2).toFixed(2)),
        dest: [(Math.random() * (x + 25 - minX + 1) | 0) + minX + this.offset.x, (Math.random() * (y + 25 - minY + 1) | 0) + minY + this.offset.y]
      };
    },
    setOffset: function setOffset(e) {
      if (this.animated) {
        var _rebase = this.rebase,
            cX = _rebase.cX,
            cY = _rebase.cY;

        this.offset.x = (e.pageX - cX) / cX * 40 | 0;
        this.offset.y = (e.pageY - cY) / cY * 40 | 0;
      }
    },
    mapToScreen: function mapToScreen(_ref4) {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
          refX = _ref5[0],
          refY = _ref5[1];

      var ref = this.$refs.svg.createSVGPoint();
      ref.x = refX;
      ref.y = refY;

      var _ref$matrixTransform = ref.matrixTransform(this.$refs.svg.getScreenCTM()),
          x = _ref$matrixTransform.x,
          y = _ref$matrixTransform.y;

      return [x | 0, y | 0];
    }
  }
};

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'icon',
  props: { id: String }
};

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'spk-logo'
};

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'svg-symbols',
  props: { name: String },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$http.get('/static/svg/' + this.name + '-symbols.svg').then(function (response) {
      return response.blob();
    }).then(function (blob) {
      var reader = new FileReader();
      reader.onload = function () {
        _this.symbols = reader.result;
      };
      reader.readAsText(blob);
    });
  },
  data: function data() {
    return {
      symbols: null
    };
  }
};

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogFilters__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BlogFilters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_meta_data__ = __webpack_require__(86);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'blog',
  components: { BlogFilters: __WEBPACK_IMPORTED_MODULE_0__BlogFilters___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_meta_data__["a" /* default */]],

  beforeMount: function beforeMount() {
    this.useHistory = this.$route.name === 'blog';
  },
  data: function data() {
    return {
      showFeed: true,
      sidebars: {
        left: { to: '/ecosysteme', modifier: 'primary' }
      }
    };
  },


  computed: {
    useCats: function useCats() {
      return this.content.filters;
    },
    content: function content() {
      return this.$store.state.content.blog;
    },
    classes: function classes() {
      return { 'blog__content--filters': this.content.filters };
    },
    mobile: function mobile() {
      return this.$media.mobile;
    },
    background: function background() {
      return {
        viewbox: {
          offsetX: this.mobile ? 300 : -700,
          offsetY: this.mobile ? 75 : -200
        },
        scale: this.mobile ? 2 : null
      };
    }
  },

  watch: {
    showFeed: function showFeed(show) {
      if (show) {
        this.updateMeta();
      } else {
        setTimeout(function () {
          document.body.scrollTop = 0;
        }, 350);
      }
    }
  }
};

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PostPreview__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PostPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PostPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PostGrid__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PostGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PostGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_api__ = __webpack_require__(47);







/* harmony default export */ __webpack_exports__["default"] = {
  name: 'blog-feed',
  components: { PostGrid: __WEBPACK_IMPORTED_MODULE_2__PostGrid___default.a, PostPreview: __WEBPACK_IMPORTED_MODULE_1__PostPreview___default.a },
  props: {
    cat: String,
    paging: String,
    featured: String
  },

  beforeMount: function beforeMount() {
    var _this = this;

    if (this.paging) {
      this.page = parseInt(this.paging);
    }

    if (!this.$parent.showFeed) {
      this.visible = false;
    }

    __WEBPACK_IMPORTED_MODULE_3_src_api__["a" /* default */].dispatch.fetchPost(this.featured).then(function (post) {
      _this.featuredPost = post;
    }).catch(function () {
      _this.featuredPost = false;
    });
  },
  data: function data() {
    return {
      page: 1,
      pages: 0,
      posts: [],
      visible: true,
      featuredPost: null,
      showFeatured: false
    };
  },


  computed: {
    firstPage: function firstPage() {
      return this.page === 1;
    },
    totalPosts: function totalPosts() {
      return this.$store.state.posts.total;
    },
    pagingOffset: function pagingOffset() {
      return this.$store.state.posts.offset;
    },
    onlyTablet: function onlyTablet() {
      return this.$media.tablet && !this.$media.desktop;
    },
    offsetFeatured: function offsetFeatured() {
      return this.$store.state.posts.offsetFeatured;
    },
    category: function category() {
      return this.$parent.useCats ? this.cat : false;
    },
    columns: function columns() {
      return this.firstPage && !this.category || this.onlyTablet ? 3 : 5;
    },
    className: function className() {
      return { 'feed--padded': this.$parent.useCats };
    },
    nextPage: function nextPage() {
      var currentPage = this.category ? this.page : this.page - 1;

      if (currentPage >= this.pages || this.totalPosts <= 6 || this.totalPosts === 7 && this.offsetFeatured) {
        return false;
      }

      return this.category ? '/blogue/categorie/' + this.category + '/page/' + (this.page + 1) : '/blogue/page/' + (this.page + 1);
    },
    prevPage: function prevPage() {
      var path = void 0;

      if (this.firstPage) {
        return false;
      }

      path = this.category ? '/blogue/categorie/' + this.category : '/blogue';

      return this.page > 2 ? path + '/page/' + (this.page - 1) : path;
    }
  },

  watch: {
    paging: function paging(to) {
      var toPage = parseInt(to);
      this.page = toPage || 1;
      this.getPosts();
    },
    category: function category() {
      this.getPosts();
    },
    onlyTablet: function onlyTablet() {
      this.getPosts();
    },
    posts: function posts() {
      setTimeout(function () {
        document.body.scrollTop = 0;
      }, 400);
    },
    '$parent.showFeed': function $parentShowFeed(isVisible) {
      var _this2 = this;

      setTimeout(function () {
        _this2.visible = isVisible;
      }, 400);
    },
    featuredPost: function featuredPost() {
      var _this3 = this;

      if (!this.pagingOffset) {
        __WEBPACK_IMPORTED_MODULE_3_src_api__["a" /* default */].dispatch.fetchPostId(5, this.featuredPost.path).then(function (_ref) {
          var id = _ref.id,
              featured = _ref.featured;

          _this3.$store.commit('posts/SET_OFFSET', id);
          _this3.$store.commit('posts/SET_OFFSET_FEATURED', featured);
          _this3.getPosts();
        }).catch(function () {
          _this3.$store.commit('posts/SET_OFFSET', '');
          _this3.getPosts();
        });
      } else {
        this.getPosts();
      }
    }
  },

  methods: {
    getPosts: function getPosts() {
      var _this4 = this;

      if (this.firstPage && !this.category) {
        var params = !this.featured ? { pageSize: 6 } : { pageSize: 6, filter: this.featured };

        __WEBPACK_IMPORTED_MODULE_3_src_api__["a" /* default */].dispatch.fetchPostFeed(params).then(function (_ref2) {
          var posts = _ref2.posts,
              pages = _ref2.pages;

          _this4.posts = posts;
          _this4.pages = parseInt(pages);
        }).catch(function () {
          console.warn('[api] Could not fetch first feed page');
          _this4.posts = false;
          _this4.pages = 1;
        });
      } else {
        var delay = this.onlyTablet ? 75 : 125;
        var pageSize = this.onlyTablet ? 9 : 10;
        var _params = this.category ? { page: this.page, category: this.category } : { page: this.page - 1 };

        __WEBPACK_IMPORTED_MODULE_3_src_api__["a" /* default */].dispatch.fetchPostFeed(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ pageSize: pageSize }, _params)).then(function (_ref3) {
          var posts = _ref3.posts,
              pages = _ref3.pages;

          _this4.posts = posts;
          _this4.pages = parseInt(pages);

          setTimeout(function () {
            _this4.showFeatured = false;
          }, delay);
        }).catch(function () {
          _this4.posts = false;
          _this4.pages = _this4.page;
        });
      }
    }
  }
};

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'blog-filters',
  computed: {
    categories: function categories() {
      var categories = this.$store.state.categories;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(categories).map(function (cat) {
        return categories[cat];
      });
    },
    noActiveFilter: function noActiveFilter() {
      return {
        'active': !~this.$route.path.indexOf('categorie')
      };
    }
  }
};

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layouts_generic__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SuggestedPosts__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SuggestedPosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SuggestedPosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_disqus_VueDisqus__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_disqus_VueDisqus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_disqus_VueDisqus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_time__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PostList__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PostList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PostList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_api__ = __webpack_require__(47);










/* harmony default export */ __webpack_exports__["default"] = {
  name: 'blog-post',
  components: { PostList: __WEBPACK_IMPORTED_MODULE_5__PostList___default.a, NewsletterForm: __WEBPACK_IMPORTED_MODULE_1_components_layouts_generic__["e" /* NewsletterForm */], SuggestedPosts: __WEBPACK_IMPORTED_MODULE_2__SuggestedPosts___default.a, VueDisqus: __WEBPACK_IMPORTED_MODULE_3_vue_disqus_VueDisqus___default.a },
  props: {
    uid: String,
    useHistory: Boolean
  },

  beforeMount: function beforeMount() {
    var _this = this;

    this.getPost().then(function () {
      _this.$emit('toggle-post');
      _this.loadComments();

      if (!_this.author) {
        _this.$store.dispatch('fetchAuthors');
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$emit('toggle-post');
  },
  data: function data() {
    return {
      moves: 1,
      post: null,
      showPost: true,
      showComments: false
    };
  },


  computed: {
    blog: function blog() {
      return this.$store.state.content.blog;
    },
    author: function author() {
      return this.$store.state.authors[this.post.author];
    },
    published: function published() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_time__["a" /* getDateTime */])({ date: this.post.published, template: '$d $M $Y', lang: 'fr' });
    },
    backClass: function backClass() {
      return { 'post__back--offset': !this.$parent.content.filters };
    },
    title: function title() {
      if (!this.post) return null;
      return this.post.fulltitle ? this.post.fulltitle[0].content : this.post.title;
    },
    metaData: function metaData() {
      return {
        title: this.$parent.content.metatitle + ' - ' + (this.post.metatitle || this.post.title),
        description: this.post.metadesc,
        openGraph: {
          image: this.post.image.crops.facebook
        }
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this2 = this;

      this.showPost = false;
      this.showComments = false;
      setTimeout(function () {
        _this2.getPost().then(function () {
          document.body.scrollTop = 0;
          _this2.$refs.post.scrollTop = 0;
          setTimeout(function () {
            _this2.moves++;
            _this2.loadComments();
            _this2.showPost = true;
          }, 100);
        });
      }, 400);
    }
  },

  methods: {
    getPost: function getPost() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_src_api__["a" /* default */].dispatch.fetchPost(this.uid).then(function (post) {
        _this3.post = post;
        _this3.updateMeta();

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }).catch(function () {
        _this3.$router.replace('/404');
      });
    },
    navBack: function navBack() {
      if (this.useHistory) {
        this.$router.go(-this.moves);
      } else {
        this.$router.push('/blogue');
      }
    },
    loadComments: function loadComments() {
      var _this4 = this;

      setTimeout(function () {
        _this4.showComments = true;
      }, 500);
    },
    updateMeta: function updateMeta() {
      this.$meta.tags = this.metaData;
    }
  }
};

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PostPreview__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PostPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PostPreview__);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'post-grid',
  components: { PostPreview: __WEBPACK_IMPORTED_MODULE_2__PostPreview___default.a },
  props: {
    modifier: String,
    visible: Boolean,
    posts: [Array, Boolean],
    link: Object,
    forceColumns: Boolean,
    columnCount: {
      type: Number,
      default: 2
    }
  },

  mounted: function mounted() {
    if (this.posts) {
      this.updatePosts(this.columnCount - 1);
    }
  },
  data: function data() {
    return {
      columns: [],
      updating: false
    };
  },


  computed: {
    params: function params() {
      return {
        paging: this.$parent.paging,
        category: this.$parent.category
      };
    },
    classes: function classes() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'grid--' + this.modifier, this.modifier), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', this.updating), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'grid--forced', this.forceColumns), _ref;
    },
    renderColumns: function renderColumns() {
      return this.$media.tablet || this.forceColumns;
    }
  },

  watch: {
    posts: function posts(newPosts, oldPosts) {
      if (this.posts) {
        this.updatePosts(Math.ceil(oldPosts.length / 2 - 1));
      }
    }
  },

  methods: {
    updatePosts: function updatePosts(delay) {
      this.updating = true;
      if (this.visible) setTimeout(this.setColumns, delay * 100 + 400);else this.setColumns();
    },
    setColumns: function setColumns() {
      var _this = this;

      var next = 0;

      if (this.posts) {
        this.columns = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(this.columnCount).keys())).map(function () {
          return Array(0);
        });

        this.posts.forEach(function (post) {
          _this.columns[next].push(post);
          next = ~(next - _this.columnCount) ? next + 1 : 0;
        });

        this.$emit('posts-loaded');

        setTimeout(function () {
          _this.updating = false;
        }, 100);
      }
    },
    getDelay: function getDelay(index) {
      return 'transition-delay: ' + index * 100 + 'ms;';
    }
  }
};

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_time__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_api__ = __webpack_require__(47);







/* harmony default export */ __webpack_exports__["default"] = {
  name: 'post-list',
  props: { preventNav: Boolean },

  mounted: function mounted() {
    this.page = 1;
  },
  data: function data() {
    return {
      page: null,
      posts: null,
      pages: null,
      update: {
        active: false,
        swap: false,
        class: null,
        post: false
      }
    };
  },


  computed: {
    nextPage: function nextPage() {
      return this.page < this.pages;
    },
    prevPage: function prevPage() {
      return this.page > 1;
    },
    classes: function classes() {
      var _ref;

      return _ref = {
        'list-swap': this.update.swap,
        'update-active': this.update.active
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'update-' + this.update.class, this.update.active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'no-click', this.preventNav), _ref;
    }
  },

  watch: {
    page: function page(to, from) {
      var _this = this;

      var delay = from ? 450 : 250;

      var _ref2 = to > from ? ['left', 'right'] : ['right', 'left'],
          _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
          oldClass = _ref3[0],
          newClass = _ref3[1];

      this.update.active = true;
      this.update.class = oldClass;

      setTimeout(function () {
        _this.update.swap = true;
        _this.update.class = newClass;

        __WEBPACK_IMPORTED_MODULE_3_src_api__["a" /* default */].dispatch.fetchPostFeed({ page: _this.page, pageSize: 6 }).then(function (_ref4) {
          var posts = _ref4.posts,
              pages = _ref4.pages;

          _this.posts = posts;
          _this.pages = pages;
          _this.update.swap = false;

          setTimeout(function () {
            _this.update.active = false;
          }, 25);
        }).catch(function () {
          _this.posts = false;
          _this.pages = 1;
        });
      }, delay);
    }
  },

  methods: {
    getElapsedTime: __WEBPACK_IMPORTED_MODULE_2_utils_time__["b" /* getElapsedTime */]
  }
};

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_text__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_time__ = __webpack_require__(74);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'post-preview',
  props: {
    post: Object,
    params: Object,
    featured: Boolean
  },

  computed: {
    cat: function cat() {
      return this.$store.state.categories[this.post.category].label;
    },
    image: function image() {
      return this.featured ? this.post.image.crops.featured : this.post.image.url;
    },
    title: function title() {
      var title = this.post.title || (this.post.fulltitle ? this.post.fulltitle[0].content : ' ');
      return this.featured ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_text__["a" /* clipText */])(title, 75) : title;
    },
    link: function link() {
      return {
        name: 'blog-post',
        params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ uid: this.post.path }, this.params)
      };
    },
    classes: function classes() {
      return {
        'preview--featured': this.featured
      };
    }
  },

  methods: {
    getElapsedTime: __WEBPACK_IMPORTED_MODULE_2_utils_time__["b" /* getElapsedTime */],
    getExcerpt: function getExcerpt() {
      var excerpt = '';
      var i = 0;

      while (!~excerpt.indexOf('...')) {
        var next = this.post.text[i];
        if (next.component === 'content-text') {
          excerpt += ' ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_text__["a" /* clipText */])(next.content, 160 - excerpt.length);
        }
        i++;
      }

      return excerpt.replace(/<[^>]+>/g, '');
    }
  }
};

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_time__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_text__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api__ = __webpack_require__(47);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'suggested-posts',
  props: {
    post: Object,
    title: String,
    count: Number,
    minimum: {
      type: Number,
      default: 2
    }
  },

  mounted: function mounted() {
    this.updating = true;
    this.getSimilarPosts(this.post.path);
  },
  data: function data() {
    return {
      posts: null,
      precision: 3,
      updating: false
    };
  },


  computed: {
    postId: function postId() {
      return this.post.id;
    }
  },

  watch: {
    postId: function postId() {
      if (!this.updating) {
        this.updating = true;
        this.getSimilarPosts(this.post.path);
      }
    }
  },

  methods: {
    getElapsedTime: __WEBPACK_IMPORTED_MODULE_0_utils_time__["b" /* getElapsedTime */],
    clipText: __WEBPACK_IMPORTED_MODULE_1_utils_text__["a" /* clipText */],
    getSimilarPosts: function getSimilarPosts(path) {
      var _this = this;

      var iterations = 0;
      this.posts = [];

      __WEBPACK_IMPORTED_MODULE_2_src_api__["a" /* default */].dispatch.fetchSimilarPosts(this.postId, this.precision, this.minimum).then(function (posts) {
        posts.forEach(function (uid) {
          __WEBPACK_IMPORTED_MODULE_2_src_api__["a" /* default */].dispatch.fetchPost(uid).then(function (post) {
            _this.posts.push(post);
            _this.updating = false;
          });
        });
      }).catch(function (posts) {
        if (iterations < 6) {
          _this.precision = Math.ceil(_this.precision * 1.3);
          _this.getSimilarPosts();
        } else {
          posts.forEach(function (uid) {
            __WEBPACK_IMPORTED_MODULE_2_src_api__["a" /* default */].dispatch.fetchPost(uid).then(function (post) {
              _this.posts.push(post);
              _this.updating = false;
            });
          });
        }
      });
    }
  }
};

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_meta_data__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EntityDetails__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EntityDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EntityDetails__);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ecosystem-view',
  components: { EntityDetails: __WEBPACK_IMPORTED_MODULE_2__EntityDetails___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_meta_data__["a" /* default */]],

  beforeMount: function beforeMount() {
    this.setLogos();
    this.setDetails([{ path: 'details', name: this.content.title, details: this.content.details }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.content.logos)));
  },
  mounted: function mounted() {
    document.body.scrollTop = 0;
  },
  data: function data() {
    return {
      sidebars: {
        left: { to: '/', modifier: 'contrast' },
        right: { to: '/blogue', modifier: 'fill' }
      },
      logos: [],
      details: {},
      ready: false
    };
  },


  computed: {
    mobile: function mobile() {
      return this.$media.phone;
    },
    content: function content() {
      return this.$store.state.content.ecosystem;
    },
    hideLogos: function hideLogos() {
      return !this.ready || !!this.$route.params.entity;
    },
    background: function background() {
      return {
        viewbox: {
          offsetX: this.mobile ? 200 : null,
          offsetY: this.mobile ? 125 : null
        },
        scale: this.mobile ? 1.5 : null
      };
    },
    padded: function padded() {
      return {
        'padded': this.hideLogos
      };
    },
    classes: function classes() {
      return {
        'hidden': !this.ready
      };
    }
  },

  methods: {
    setLogos: function setLogos() {
      var _this = this;

      ['c', 'g', 'h', 'i'].some(function (key, index) {
        var logo = _this.content.logos[index];

        if (logo.image && logo.image.url) {
          _this.logos.push({
            url: logo.image.url,
            path: logo.path,
            name: logo.name,
            key: key
          });
        }

        return index + 1 === _this.content.logos.length;
      });
    },
    setDetails: function setDetails(entities) {
      var _this2 = this;

      entities.forEach(function (_ref) {
        var path = _ref.path,
            title = _ref.name,
            details = _ref.details,
            image = _ref.image,
            url = _ref.url;

        _this2.details[path] = {
          path: path,
          title: title,
          details: details,
          image: image,
          url: url
        };
      });
    }
  }
};

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'entity-details',
  props: {
    entity: String,
    details: Object
  },

  computed: {
    content: function content() {
      return this.details[this.entity];
    }
  }
};

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventPreview__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EventPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventGrid__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EventGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_api__ = __webpack_require__(47);








/* harmony default export */ __webpack_exports__["default"] = {
  name: 'event-calendar',
  components: { EventGrid: __WEBPACK_IMPORTED_MODULE_3__EventGrid___default.a, EventPreview: __WEBPACK_IMPORTED_MODULE_2__EventPreview___default.a },
  props: {
    paging: String
  },

  beforeMount: function beforeMount() {
    if (this.paging) this.page = parseInt(this.paging);
    if (!this.feed) __WEBPACK_IMPORTED_MODULE_4_src_api__["a" /* default */].dispatch.fetchAllEvents(this.featuredId);
  },
  data: function data() {
    return {
      ready: false
    };
  },


  computed: {
    page: function page() {
      return !this.paging ? 1 : parseInt(this.paging);
    },
    featuredEvent: function featuredEvent() {
      return this.$store.state.events.featured;
    },
    featuredId: function featuredId() {
      return this.$store.state.content.calendar.featured;
    },
    pages: function pages() {
      return !this.feed ? 0 : Math.ceil(this.feed.length / 4);
    },
    feed: function feed() {
      var events = this.$store.state.events.feed;
      if (!events) return false;
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(events.active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(events.inactive.map(function (e) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, e, { inactive: true });
      })));
    },
    events: function events() {
      var start = 4 * (this.page - 1);
      return !this.feed ? [] : this.feed.slice(start, start + 4);
    },
    nextPage: function nextPage() {
      if (this.page >= this.pages) return false;
      return '/evenements/page/' + (this.page + 1);
    },
    prevPage: function prevPage() {
      if (this.page === 1) return false;
      return this.page > 2 ? '/evenements/page/' + (this.page - 1) : '/evenements';
    }
  },

  watch: {
    events: function events(to) {
      if (!this.ready && to.length) this.ready = true;

      setTimeout(function () {
        document.body.scrollTop = 0;
      }, 400);
    }
  }
};

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventPreview__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EventPreview__);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'event-grid',
  components: { EventPreview: __WEBPACK_IMPORTED_MODULE_2__EventPreview___default.a },
  props: {
    events: [Array, Boolean],
    columnCount: {
      type: Number,
      default: 2
    }
  },

  mounted: function mounted() {
    if (this.events) {
      this.updateEvents(this.columnCount - 1);
    }
  },
  data: function data() {
    return {
      columns: [],
      updating: false
    };
  },


  computed: {
    params: function params() {
      return {
        paging: this.$parent.paging
      };
    },
    classes: function classes() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'grid--' + this.modifier, this.modifier), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', this.updating), _ref;
    },
    renderColumns: function renderColumns() {
      return this.$media.tablet;
    }
  },

  watch: {
    events: function events(newEvents, oldEvents) {
      if (newEvents) {
        this.updateEvents(Math.ceil(oldEvents.length / 2 - 1));
      }
    }
  },

  methods: {
    updateEvents: function updateEvents(delay) {
      this.updating = true;
      setTimeout(this.setColumns, delay * 100 + 400);
    },
    setColumns: function setColumns() {
      var _this = this;

      var next = 0;

      if (this.events) {
        this.columns = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(this.columnCount).keys())).map(function () {
          return Array(0);
        });

        this.events.forEach(function (evt) {
          _this.columns[next].push(evt);
          next = ~(next - _this.columnCount) ? next + 1 : 0;
        });

        this.$emit('events-loaded');

        setTimeout(function () {
          _this.updating = false;
        }, 100);
      }
    },
    getDelay: function getDelay(index) {
      return 'transition-delay: ' + index * 100 + 'ms;';
    }
  }
};

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_text__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_time__ = __webpack_require__(74);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'event-preview',
  props: {
    evt: Object,
    params: Object,
    featured: Boolean
  },

  computed: {
    image: function image() {
      return this.featured ? this.evt.image.crops.featured : this.evt.image.url;
    },
    date: function date() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_time__["a" /* getDateTime */])({ date: this.evt.date, template: '$d $M $Y', lang: 'fr' });
    },
    name: function name() {
      return this.evt.name[0].content;
    },
    description: function description() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_text__["a" /* clipText */])(this.evt.description, 150);
    },
    type: function type() {
      if (!this.evt.type) return { name: 'Événement', tag: 'event' };

      var _evt$type$split$map = this.evt.type.split('[').map(function (w) {
        return w.replace(/]/, '').replace(/^ /, '').replace(/ $/, '');
      }),
          _evt$type$split$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_evt$type$split$map, 2),
          name = _evt$type$split$map2[0],
          tag = _evt$type$split$map2[1];

      return { name: name, tag: tag };
    },
    classes: function classes() {
      return {
        'preview--nolink': !this.evt.link,
        'preview--featured': this.featured,
        'preview--inactive': this.evt.inactive
      };
    }
  }
};

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_meta_data__ = __webpack_require__(86);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'events',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_meta_data__["a" /* default */]],

  data: function data() {
    return {
      sidebars: {
        left: { to: '/blogue', modifier: 'fill' }
      }
    };
  },


  computed: {
    content: function content() {
      return this.$store.state.content.calendar;
    },
    mobile: function mobile() {
      return this.$media.mobile;
    },
    background: function background() {
      return {
        scale: this.mobile ? 2 : null,
        viewbox: {
          offsetX: this.mobile ? 300 : -700,
          offsetY: this.mobile ? 75 : -200
        }
      };
    }
  }
};

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'authors-view',
  mounted: function mounted() {
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.authors).length) {
      this.$store.dispatch('fetchAuthors');
    } else {
      this.ready = true;
      this.$emit('panel-open');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$emit('panel-close');
  },
  data: function data() {
    return {
      ready: false
    };
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    authors: function authors(state) {
      return state.authors;
    },
    banner: function banner(state) {
      return state.content.meta.authors;
    }
  }),

  watch: {
    authors: function authors() {
      if (!this.ready) {
        this.ready = true;
        this.$emit('panel-open');
      }
    }
  }
};

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'contact-view',
  mounted: function mounted() {
    this.$emit('panel-open');
  },
  beforeDestroy: function beforeDestroy() {
    this.$emit('panel-close');
  },
  data: function data() {
    return {
      success: false,
      submitted: false,
      fields: {
        name: {
          value: null,
          valid: true,
          required: true,
          sanitize: [/<[^>]+>/g]
        },
        email: {
          value: null,
          valid: true,
          required: true,
          pattern: /[^\s@]+@[^\s@]+\.[^\s@]+/
        },
        message: {
          value: null,
          valid: true,
          required: true,
          sanitize: [/<[^>]+>/g]
        }
      }
    };
  },


  computed: {
    entries: function entries() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fields).map(function (name) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ name: name }, _this.fields[name]);
      });
    },
    content: function content() {
      var _$store$state$content = this.$store.state.content.meta,
          banner = _$store$state$content.contact,
          address = _$store$state$content.address,
          phone = _$store$state$content.phone,
          email = _$store$state$content.email;

      return { banner: banner, address: address, phone: phone, email: email };
    },
    form: function form() {
      return {
        'submitted': this.submitted
      };
    },
    submitButton: function submitButton() {
      return {
        'button--disabled': this.submitted
      };
    },
    successMessage: function successMessage() {
      return {
        'contact__success--visible': this.success
      };
    }
  },

  methods: {
    valid: function valid() {
      var _this2 = this;

      return this.entries.every(function (field) {
        var notNull = !field.required || !!(field.value && field.value.replace(/\s/g, '').length);
        var matches = !field.pattern || field.pattern.test(field.value);
        var valid = notNull && matches;
        _this2.fields[field.name].valid = valid;
        return valid;
      });
    },
    getFormData: function getFormData() {
      var formData = { 'form-name': this.$refs.form.attributes.name.value };

      this.entries.forEach(function (_ref) {
        var name = _ref.name,
            value = _ref.value,
            sanitize = _ref.sanitize;

        if (sanitize && value) {
          sanitize.forEach(function (pattern) {
            value = value.replace(pattern, '');
          });
        }

        formData[name] = value;
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(formData);
    },
    send: function send() {
      var _this3 = this;

      if (!this.submitted) {
        this.submitted = true;

        if (this.valid()) {
          this.getFormData().then(function (formData) {
            _this3.$http.post(_this3.$refs.form.attributes.action.value, formData, { emulateJSON: true }).then(function (response) {
              _this3.success = true;
            });
          });
        } else {
          this.submitted = false;
        }
      }
    }
  }
};

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'newsletter-form',
  props: {
    content: Object
  },

  data: function data() {
    return {
      value: '',
      valid: true,
      success: false,
      submitted: false
    };
  },


  computed: {
    formClasses: function formClasses() {
      return {
        'success': this.success,
        'submitted': this.submitted
      };
    },
    submitButton: function submitButton() {
      return {
        'button--disabled': this.submitted
      };
    }
  },

  methods: {
    send: function send() {
      var _this = this;

      if (!this.submitted) {
        this.submitted = true;

        if (this.value.length && /[^\s@]+@[^\s@]+\.[^\s@]+/.test(this.value)) {
          var formData = {
            'form-name': this.$refs.form.attributes.name.value,
            'email': this.value
          };

          this.$http.post(this.$refs.form.attributes.action.value, formData, { emulateJSON: true }).then(function (response) {
            _this.success = true;
          });
        } else {
          this.valid = false;
          this.submitted = false;
        }
      }
    }
  }
};

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NewsletterForm__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NewsletterForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NewsletterForm__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'newsletter-panel',
  components: { NewsletterForm: __WEBPACK_IMPORTED_MODULE_0__NewsletterForm___default.a },
  mounted: function mounted() {
    this.$emit('panel-open');
  },
  beforeDestroy: function beforeDestroy() {
    this.$emit('panel-close');
  },


  computed: {
    message: function message() {
      return this.$store.state.content.meta['signup-message'];
    },
    content: function content() {
      var _$store$state$content = this.$store.state.content.meta,
          title = _$store$state$content['signup-title'],
          submit = _$store$state$content['signup-label'];

      return {
        title: title,
        submit: submit,
        placeholder: 'Courriel'
      };
    }
  }
};

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'not-found'
};

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_layouts_blog__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_meta_data__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api__ = __webpack_require__(47);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'home-view',
  components: { PostGrid: __WEBPACK_IMPORTED_MODULE_0_components_layouts_blog__["d" /* PostGrid */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_meta_data__["a" /* default */]],

  beforeMount: function beforeMount() {
    var _this = this;

    if (this.toggleContent) this.toggle = true;

    __WEBPACK_IMPORTED_MODULE_2_src_api__["a" /* default */].dispatch.fetchPostCollection(this.content.featured.map(function (_ref) {
      var post = _ref.post;
      return post;
    })).then(function (_ref2) {
      var posts = _ref2.posts;

      _this.posts = posts;
      _this.ready = true;
    });
  },
  data: function data() {
    return {
      moves: 1,
      posts: [],
      ready: false,
      toggle: false,
      sidebars: {
        right: { to: '/ecosysteme', modifier: 'primary' }
      }
    };
  },


  computed: {
    toggleContent: function toggleContent() {
      return this.$route.name !== 'home';
    },
    content: function content() {
      return this.$store.state.content.home;
    },
    offsetX: function offsetX() {
      return this.$media.mobile ? null : -650;
    },
    offsetY: function offsetY() {
      return this.$media.mobile ? 200 : null;
    },
    backgroundScale: function backgroundScale() {
      return this.$media.mobile ? 2 : null;
    }
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.name !== 'home' && from.name !== 'home') {
        this.moves++;
      } else {
        this.moves = 1;
      }
    },
    toggleContent: function toggleContent(to) {
      var _this2 = this;

      if (to) {
        this.toggle = true;
        document.body.scrollTop = 0;
      } else {
        setTimeout(function () {
          _this2.toggle = false;
          document.body.scrollTop = 0;
        }, 400);
      }
    }
  },

  methods: {
    navBack: function navBack() {
      if (this.$store.state.moves) {
        this.$router.go(-this.moves);
      } else {
        this.$router.push('/');
      }
    }
  }
};

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'button-link',
  props: {
    to: String,
    type: String
  }
};

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideBar__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SideBar__);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'footer-nav',
  components: { SideBar: __WEBPACK_IMPORTED_MODULE_1__SideBar___default.a },
  props: {
    modifier: String,
    sidebars: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  computed: {
    nodes: function nodes() {
      return this.$router.options.routes.map(function (_ref) {
        var path = _ref.path,
            meta = _ref.meta;
        return { path: path, meta: meta };
      });
    },
    homeNode: function homeNode() {
      return this.$router.options.routes[0];
    },
    classes: function classes() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'footer--' + this.modifier, this.modifier);
    }
  }
};

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MobileMenu__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MobileMenu__);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'header-nav',
  components: { MobileMenu: __WEBPACK_IMPORTED_MODULE_1__MobileMenu___default.a },
  props: { modifier: String },

  data: function data() {
    return {
      expand: false
    };
  },


  computed: {
    mobile: function mobile() {
      return this.$media.mobile;
    },
    links: function links() {
      return this.$store.state.content.meta.links;
    },
    social: function social() {
      return {
        accounts: this.$store.state.content.meta.accounts,
        label: this.$store.state.content.meta.label
      };
    },
    classes: function classes() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'header--' + this.modifier, this.modifier), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'header--menu-open', this.expand), _ref;
    },
    burgerState: function burgerState() {
      return {
        'burger--close': this.expand
      };
    }
  }
};

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'mobile-menu',
  props: {
    links: Array,
    expand: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('touchmove', this.preventScroll);
  },
  data: function data() {
    return {
      height: window.innerHeight
    };
  },


  computed: {
    nodes: function nodes() {
      return this.$router.options.routes.map(function (_ref) {
        var path = _ref.path,
            meta = _ref.meta;
        return { path: path, meta: meta };
      });
    },
    homeNode: function homeNode() {
      return this.$router.options.routes[0];
    },
    classes: function classes() {
      return {
        'menu--open': this.expand
      };
    }
  },

  watch: {
    expand: function expand(expanded) {
      if (expanded) {
        this.height = window.innerHeight;
        document.addEventListener('touchmove', this.preventScroll, { passive: false });
      } else {
        document.removeEventListener('touchmove', this.preventScroll);
      }
    }
  },

  methods: {
    manage: function manage(e) {
      if (e.target.classList.contains('menu__link')) {
        this.$emit('menu-close');
      }
    },
    preventScroll: function preventScroll(e) {
      e.preventDefault();
    }
  }
};

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'side-bar',
  props: {
    modifier: String,
    left: Boolean,
    to: String
  },

  computed: {
    label: function label() {
      var _this = this;

      return this.$router.options.routes.find(function (route) {
        return route.path === _this.to;
      }).meta.label;
    },
    social: function social() {
      return {
        accounts: this.$store.state.content.meta.accounts,
        label: this.$store.state.content.meta.label
      };
    },
    classes: function classes() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'sidebar--left': this.left,
        'sidebar--right': !this.left,
        'sidebar--linked': this.to
      }, 'sidebar--' + this.modifier, this.modifier);
    }
  }
};

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(631),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  "data-v-0fe2d5ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$media.desktop) ? _c('footer', {
    staticClass: "footer",
    class: _vm.classes
  }, [_c('nav', {
    staticClass: "footer__nav"
  }, [_c('router-link', {
    staticClass: "footer__node",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.homeNode.meta.label))]), _vm._v(" "), _vm._l((_vm.nodes), function(node) {
    return (!node.meta.hidden && node.meta.index) ? _c('router-link', {
      staticClass: "footer__node",
      attrs: {
        "to": node.path
      }
    }, [_vm._v(_vm._s(node.meta.label))]) : _vm._e()
  })], 2), _vm._v(" "), _c('side-bar', {
    attrs: {
      "left": true,
      "to": _vm.sidebars.left ? _vm.sidebars.left.to : null,
      "modifier": _vm.sidebars.left ? _vm.sidebars.left.modifier : null
    }
  }), _vm._v(" "), (_vm.sidebars.right) ? _c('side-bar', {
    attrs: {
      "to": _vm.sidebars.right.to,
      "modifier": _vm.sidebars.right.modifier
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "background__banner home__banner"
  }, [_vm._v(_vm._s(_vm.content.banner))]), _vm._v(" "), _c('section', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "contact__info"
  }, [_c('h4', {
    staticClass: "contact__label contact__label--info"
  }, [_vm._v("coordonnées")]), _vm._v(" "), _c('address', {
    staticClass: "contact__item"
  }, [_vm._v(_vm._s(_vm.content.address))]), _vm._v(" "), _c('span', [_c('h5', {
    staticClass: "contact__item"
  }, [_vm._v(_vm._s(_vm.content.phone))]), _vm._v(" "), _c('h5', {
    staticClass: "contact__item"
  }, [_vm._v(_vm._s(_vm.content.email))])])]), _vm._v(" "), _c('form', {
    ref: "form",
    staticClass: "contact__form",
    class: _vm.form,
    attrs: {
      "name": "contact-form",
      "action": "/",
      "method": "post",
      "netlify": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send($event)
      }
    }
  }, [_c('fieldset', {
    staticClass: "contact__field"
  }, [_c('label', {
    staticClass: "contact__label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("nom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.name.value),
      expression: "fields.name.value"
    }],
    staticClass: "contact__input",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text",
      "autocomplete": "name",
      "autocapitalize": "words",
      "autocorrect": "off",
      "spellcheck": "false",
      "data-invalid": !_vm.fields.name.valid
    },
    domProps: {
      "value": _vm._s(_vm.fields.name.value)
    },
    on: {
      "focus": function($event) {
        _vm.fields.name.valid = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fields.name.value = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('fieldset', {
    staticClass: "contact__field"
  }, [_c('label', {
    staticClass: "contact__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("courriel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.email.value),
      expression: "fields.email.value"
    }],
    staticClass: "contact__input",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "text",
      "autocomplete": "email",
      "data-invalid": !_vm.fields.email.valid
    },
    domProps: {
      "value": _vm._s(_vm.fields.email.value)
    },
    on: {
      "focus": function($event) {
        _vm.fields.email.valid = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fields.email.value = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('fieldset', {
    staticClass: "contact__field contact__field--full"
  }, [_c('label', {
    staticClass: "contact__label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.message.value),
      expression: "fields.message.value"
    }],
    staticClass: "contact__input contact__input--message",
    attrs: {
      "id": "message",
      "name": "message",
      "data-invalid": !_vm.fields.message.valid
    },
    domProps: {
      "value": _vm._s(_vm.fields.message.value)
    },
    on: {
      "focus": function($event) {
        _vm.fields.message.valid = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fields.message.value = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button button--fill",
    class: _vm.submitButton
  }, [_c('span', {
    staticClass: "button__bg"
  }, [_c('svg', {
    staticClass: "button__fold button__fold--c"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-c"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "button__fold button__fold--b"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-b"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "button__fold button__fold--a"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-a"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "button__label"
  }, [_vm._v("envoyer")])]), _vm._v(" "), _c('div', {
    staticClass: "contact__message"
  }, [_c('span', {
    staticClass: "contact__success",
    class: _vm.successMessage
  }, [_vm._v("Votre message a bien été envoyé, merci!")])])])])])
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.post) ? _c('section', {
    staticClass: "post"
  }, [_c('post-list', {
    staticClass: "post__list",
    attrs: {
      "prevent-nav": !_vm.showPost
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "post__scrollbox"
  }, [_c('transition', {
    attrs: {
      "name": "swap"
    }
  }, [_c('article', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPost),
      expression: "showPost"
    }],
    ref: "post",
    staticClass: "post__content"
  }, [_c('h1', {
    staticClass: "post__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('time', {
    staticClass: "post__published"
  }, [_vm._v(_vm._s(_vm.published))]), _vm._v(" "), _c('figure', {
    staticClass: "post__feature"
  }, [(_vm.post.image) ? _c('img', {
    staticClass: "post__image",
    attrs: {
      "src": _vm.post.image.url,
      "alt": _vm.post.image.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/blogue/categorie/" + (_vm.post.category))
    }
  }, [_c('icon', {
    staticClass: "post__category",
    class: ("post__category--" + (_vm.post.category)),
    attrs: {
      "id": _vm.post.category
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "post__body rte"
  }, _vm._l((_vm.post.text), function(item) {
    return _c(item.component, {
      key: item,
      tag: "component",
      attrs: {
        "item": item
      }
    })
  })), _vm._v(" "), _c('footer', [(_vm.author) ? _c('div', {
    staticClass: "post__footer author author--post"
  }, [_c('img', {
    staticClass: "author__photo",
    attrs: {
      "src": _vm.author.photo.url,
      "alt": _vm.author.photo.alt
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "author__name"
  }, [_vm._v(_vm._s(_vm.author.name))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.author.title))])])]) : _vm._e(), _vm._v(" "), _c('newsletter-form', {
    staticClass: "post__footer",
    attrs: {
      "content": {
        title: _vm.blog.newsletter,
        submit: _vm.blog.submit,
        placeholder: 'Courriel'
      }
    }
  }), _vm._v(" "), _c('suggested-posts', {
    staticClass: "post__footer",
    attrs: {
      "post": _vm.post,
      "count": 3,
      "title": _vm.blog.suggested
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disqus"
  }, [(_vm.showComments) ? _c('vue-disqus', {
    key: _vm.uid,
    attrs: {
      "shortname": "spk-blog",
      "identifier": _vm.uid,
      "url": ("https://www.spk.rocks/blogue/" + _vm.uid)
    }
  }) : _vm._e()], 1)], 1)])])], 1), _vm._v(" "), _c('button', {
    staticClass: "post__back",
    class: _vm.backClass,
    on: {
      "click": _vm.navBack
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object', {
    domProps: {
      "innerHTML": _vm._s(_vm.symbols)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suggested"
  }, [_c('h5', {
    staticClass: "suggested__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.posts) ? _c('ul', {
    staticClass: "suggested__list"
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', {
      staticClass: "suggested__post"
    }, [_c('router-link', {
      attrs: {
        "to": post.path
      }
    }, [_vm._v(_vm._s(_vm.clipText(post.title, 60)))]), _vm._v(" "), _c('time', {
      staticClass: "suggested__published"
    }, [_c('icon', {
      attrs: {
        "id": 'clock'
      }
    }), _vm._v("Il y a " + _vm._s(_vm.getElapsedTime({
      date: post.published,
      lang: 'fr'
    })))], 1)], 1)
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "home",
    attrs: {
      "data-toggle": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "background"
  }, [_c('background-vector', {
    staticClass: "home__vector",
    attrs: {
      "alpha": 0.25,
      "scale": _vm.backgroundScale,
      "viewbox": {
        offsetX: _vm.offsetX,
        offsetY: _vm.offsetY
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "background__banner home__banner toggle-content"
  }, [_vm._v(_vm._s(_vm.content.banner))])], 1), _vm._v(" "), _c('section', {
    staticClass: "home__content home__desc toggle-content"
  }, [_c('h1', {
    staticClass: "home__title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _c('h2', {
    staticClass: "home__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subtitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rte"
  }, _vm._l((_vm.content.text), function(item) {
    return _c(item.component, {
      tag: "component",
      attrs: {
        "item": item
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "home__logos"
  }, _vm._l((_vm.content.logos), function(ref) {
    var url = ref.url;
    var image = ref.image;

    return _c('safe-link', {
      staticClass: "home__link",
      attrs: {
        "url": url
      }
    }, [_c('img', {
      staticClass: "home__link--logo",
      attrs: {
        "src": image.url,
        "alt": image.alt
      }
    })])
  })), _vm._v(" "), _c('button-link', {
    staticClass: "home__cta",
    attrs: {
      "type": "fill",
      "to": _vm.content.path
    }
  }, [_vm._v(_vm._s(_vm.content.label))])], 1), _vm._v(" "), (_vm.$media.mobile) ? _c('h3', {
    staticClass: "home__banner--mobile toggle-content"
  }, [_vm._v(_vm._s(_vm.content.banner))]) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('post-grid', {
    staticClass: "home__content grid--home toggle-content",
    attrs: {
      "posts": _vm.posts,
      "forceColumns": !_vm.$media.mobile,
      "link": {
        to: '/blogue',
        label: _vm.content.bloglabel
      }
    }
  }) : _c('div', {
    staticClass: "home__content toggle-content"
  }), _vm._v(" "), (_vm.$media.phone) ? _c('button-link', {
    staticClass: "grid__link toggle-content",
    attrs: {
      "to": "/blogue",
      "type": "border"
    }
  }, [_vm._v(_vm._s(_vm.content.bloglabel))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "up"
    }
  }, [_c('router-view', {
    staticClass: "home__panel"
  })], 1), _vm._v(" "), _c('header-nav'), _vm._v(" "), _c('footer-nav', {
    staticClass: "toggle-content",
    attrs: {
      "sidebars": _vm.sidebars
    }
  }), _vm._v(" "), (!_vm.$media.mobile) ? _c('button', {
    staticClass: "home__back",
    on: {
      "click": _vm.navBack
    }
  }, [_vm._v("retour "), _c('icon', {
    attrs: {
      "id": 'return'
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    class: _vm.classes
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('spk-logo', {
    staticClass: "header__logo"
  })], 1), _vm._v(" "), (_vm.mobile) ? _c('ul', {
    staticClass: "header__social"
  }, _vm._l((_vm.social.accounts), function(account) {
    return _c('li', {
      staticClass: "header__account"
    }, [_c('a', {
      attrs: {
        "href": account.url,
        "target": "_blank"
      }
    }, [_c('icon', {
      attrs: {
        "id": account.icon
      }
    })], 1)])
  })) : _vm._e(), _vm._v(" "), (_vm.mobile) ? _c('mobile-menu', {
    attrs: {
      "expand": _vm.expand,
      "links": _vm.links
    },
    on: {
      "menu-close": function($event) {
        _vm.expand = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mobile) ? _c('button', {
    staticClass: "burger",
    class: _vm.burgerState,
    on: {
      "click": function($event) {
        _vm.expand = !_vm.expand
      }
    }
  }, [_c('i', {
    staticClass: "burger--icon"
  })]) : _vm._e(), _vm._v(" "), (!_vm.mobile) ? _c('nav', [_vm._l((_vm.links), function(link) {
    return _c('router-link', {
      staticClass: "header__link",
      attrs: {
        "to": link.path
      }
    }, [_vm._v(_vm._s(link.label))])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "header__link header__link--cta",
    attrs: {
      "to": "/infolettre"
    }
  }, [_c('icon', {
    attrs: {
      "id": "newsletter"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Infolettre")])], 1)], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "background"
  }, [_c('h3', {
    staticClass: "background__banner home__banner home__banner--panel"
  }, [_vm._v(_vm._s(_vm.banner))])]), _vm._v(" "), (_vm.ready) ? _c('section', {
    staticClass: "author__list"
  }, _vm._l((_vm.authors), function(author) {
    return (!author.hidden) ? _c('div', {
      staticClass: "author"
    }, [_c('figure', {
      staticClass: "author__figure"
    }, [(author.photo) ? _c('img', {
      attrs: {
        "src": author.photo.url,
        "alt": author.photo.alt
      }
    }) : _vm._e()]), _vm._v(" "), _c('ul', {
      staticClass: "author__social"
    }, [_vm._l((author.accounts), function(account) {
      return _c('li', {
        staticClass: "author__link"
      }, [_c('a', {
        attrs: {
          "href": account.url,
          "target": "_blank"
        }
      }, [_c('icon', {
        attrs: {
          "id": account.network
        }
      })], 1)])
    }), _vm._v(" "), (author.photo) ? _c('li', {
      staticClass: "author__overflow",
      style: (("background-image:url(" + (author.photo.url) + ");"))
    }) : _vm._e()], 2), _vm._v(" "), _c('h4', {
      staticClass: "author__name"
    }, [_vm._v(_vm._s(author.name))]), _vm._v(" "), _c('h5', {
      staticClass: "author__title"
    }, [_vm._v(_vm._s(author.title))])]) : _vm._e()
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-wrapper', {
    attrs: {
      "tag": _vm.item.props.tag
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.content)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    style: (("width:" + (_vm.content.width) + "px;")),
    attrs: {
      "src": _vm.content.url,
      "alt": _vm.content.alt
    }
  }), _vm._v(" "), (_vm.content.caption && _vm.content.caption.length) ? _c('figcaption', [_vm._v(_vm._s(_vm.content.caption))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewport",
    attrs: {
      "id": "app"
    }
  }, [_c('svg-symbols', {
    attrs: {
      "name": "icon"
    }
  }), _vm._v(" "), _c('svg-symbols', {
    attrs: {
      "name": "button"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.ready) ? _c('div', {
    key: _vm.viewIndex,
    staticClass: "view"
  }, [_c('router-view', {
    staticClass: "view__content slide--inner"
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feed"
  }, [_c('transition', {
    attrs: {
      "name": "feature",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "feed__featured"
  }, [(_vm.featuredEvent) ? _c('event-preview', {
    attrs: {
      "evt": _vm.featuredEvent,
      "featured": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('event-grid', {
    staticClass: "feed__grid",
    attrs: {
      "events": _vm.events
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "feed__nav"
  }, [_c('router-link', {
    staticClass: "paging paging--prev",
    attrs: {
      "to": _vm.prevPage || '',
      "tag": "button",
      "data-disabled": !_vm.prevPage
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "paging",
    attrs: {
      "to": _vm.nextPage || '',
      "tag": "button",
      "data-disabled": !_vm.nextPage
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "blog__filters"
  }, [_c('li', {
    staticClass: "blog__filter",
    class: _vm.noActiveFilter
  }, [_c('router-link', {
    staticClass: "blog__filter--link",
    attrs: {
      "to": "/blogue"
    }
  }, [_vm._v(_vm._s('Tous'))])], 1), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('router-link', {
      class: ("blog__filter blog__filter--" + (category.name)),
      attrs: {
        "to": ("/blogue/categorie/" + (category.name)),
        "tag": "li"
      }
    }, [_c('a', {
      staticClass: "blog__filter--link"
    }, [_c('icon', {
      attrs: {
        "id": category.name
      }
    }), _c('span', {
      staticClass: "blog__filter--label"
    }, [_vm._v(_vm._s(category.label))])], 1)])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "not-found"
  }, [_c('div', [_c('h2', {
    staticClass: "not-found__title"
  }, [_vm._v("404")]), _vm._v(" "), _c('p', [_vm._v("La page que vous cherchez n'existe pas.")]), _vm._v(" "), _c('router-link', {
    staticClass: "not-found__link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Page d'accueil")])], 1), _vm._v(" "), _c('header-nav'), _vm._v(" "), _c('footer-nav')], 1)
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsletter"
  }, [_c('h5', {
    staticClass: "newsletter__title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('form', {
    ref: "form",
    staticClass: "newsletter__form",
    class: _vm.formClasses,
    attrs: {
      "name": "newsletter-form",
      "action": "/",
      "method": "post",
      "netlify": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "newsletter__input",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "text",
      "autocomplete": "email",
      "placeholder": _vm.content.placeholder,
      "data-invalid": !_vm.valid
    },
    domProps: {
      "value": _vm._s(_vm.value)
    },
    on: {
      "focus": function($event) {
        _vm.valid = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button button--fill newsletter__submit",
    class: _vm.submitButton
  }, [_c('span', {
    staticClass: "button__bg"
  }, [_c('svg', {
    staticClass: "button__fold button__fold--c"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-c"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "button__fold button__fold--b"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-b"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "button__fold button__fold--a"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-a"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "button__label"
  }, [_vm._v(_vm._s(_vm.content.submit))])]), _vm._v(" "), _c('h6', {
    staticClass: "newsletter__success"
  }, [_vm._v("Vous êtes maintenant abonné à l'infolettre!")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feed",
    class: _vm.className
  }, [_c('transition', {
    attrs: {
      "name": "feature",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFeatured),
      expression: "showFeatured"
    }],
    staticClass: "feed__featured"
  }, [(_vm.featuredPost) ? _c('post-preview', {
    attrs: {
      "post": _vm.featuredPost,
      "featured": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('post-grid', {
    staticClass: "feed__grid",
    attrs: {
      "visible": _vm.visible,
      "posts": _vm.posts,
      "column-count": _vm.columns
    },
    on: {
      "posts-loaded": function($event) {
        _vm.showFeatured = _vm.firstPage && !_vm.category
      }
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "feed__nav"
  }, [_c('router-link', {
    staticClass: "paging paging--prev",
    attrs: {
      "to": _vm.prevPage || '',
      "tag": "button",
      "data-disabled": !_vm.prevPage
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "paging",
    attrs: {
      "to": _vm.nextPage || '',
      "tag": "button",
      "data-disabled": !_vm.nextPage
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "disqus_thread"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    class: ("button button--" + _vm.type),
    attrs: {
      "to": _vm.to
    }
  }, [(_vm.type === 'border') ? _c('svg', {
    staticClass: "button__border"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-border"
    }
  })]) : _c('span', {
    staticClass: "button__bg"
  }, [_c('svg', {
    staticClass: "button__fold button__fold--c"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-c"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "button__fold button__fold--b"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-b"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "button__fold button__fold--a"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-a"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "button__label"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.events) ? _c('section', {
    staticClass: "grid grid--calendar",
    class: _vm.classes
  }, [(_vm.renderColumns) ? _vm._l((_vm.columns), function(column, index) {
    return _c('div', {
      staticClass: "grid__column",
      style: (_vm.getDelay(index))
    }, _vm._l((column), function(evt) {
      return _c('event-preview', {
        key: evt,
        staticClass: "grid__item",
        attrs: {
          "evt": evt,
          "params": _vm.params
        }
      })
    }))
  }) : _vm._l((_vm.events), function(evt, index) {
    return _c('event-preview', {
      key: evt,
      staticClass: "grid__item",
      style: (_vm.getDelay(index)),
      attrs: {
        "evt": evt,
        "params": _vm.params
      }
    })
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "preview",
    class: _vm.classes
  }, [_c('router-link', {
    staticClass: "preview__link",
    attrs: {
      "to": _vm.link
    }
  }, [(_vm.post.image) ? _c('img', {
    staticClass: "preview__img",
    attrs: {
      "src": _vm.image,
      "alt": _vm.post.image.alt
    }
  }) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "preview__content",
    attrs: {
      "to": _vm.link
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/blogue/categorie/" + (_vm.post.category))
    }
  }, [_c('icon', {
    class: ("preview__icon preview__icon--" + (_vm.post.category)),
    attrs: {
      "id": _vm.post.category
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "preview__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.featured) ? _c('p', [_vm._v(_vm._s(_vm.getExcerpt()))]) : _vm._e(), _vm._v(" "), _c('p', {
    class: ("preview__cat preview__cat--" + (_vm.post.category))
  }, [_vm._v(_vm._s(_vm.cat))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', _vm._l((_vm.item.content), function(li) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(li)
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "blog"
  }, [_c('div', {
    staticClass: "background"
  }, [_c('background-vector', {
    staticClass: "blog__vector",
    attrs: {
      "alpha": 0.15,
      "scale": _vm.background.scale,
      "viewbox": _vm.background.viewbox,
      "rotate": -40
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "background__banner blog__banner"
  }, [_vm._v(_vm._s(_vm.content.banner))])], 1), _vm._v(" "), (_vm.useCats) ? _c('blog-filters') : _vm._e(), _vm._v(" "), _c('div', {
    ref: "feed",
    staticClass: "blog__content",
    class: _vm.classes
  }, [_c('transition', {
    attrs: {
      "name": "feed"
    }
  }, [_c('router-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFeed),
      expression: "showFeed"
    }],
    attrs: {
      "featured": _vm.content.featured
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "post"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "post",
      "use-history": _vm.useHistory
    },
    on: {
      "toggle-post": function($event) {
        _vm.showFeed = !_vm.showFeed
      }
    }
  })], 1)], 1), _vm._v(" "), _c('header-nav', {
    attrs: {
      "modifier": "blog"
    }
  }), _vm._v(" "), _c('footer-nav', {
    attrs: {
      "sidebars": _vm.sidebars
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.posts) ? _c('section', {
    staticClass: "grid",
    class: _vm.classes
  }, [(_vm.renderColumns) ? _vm._l((_vm.columns), function(column, index) {
    return _c('div', {
      staticClass: "grid__column",
      style: (_vm.getDelay(index))
    }, [_vm._l((column), function(post) {
      return _c('post-preview', {
        key: post,
        staticClass: "grid__item",
        attrs: {
          "post": post,
          "params": _vm.params
        }
      })
    }), _vm._v(" "), (!~(index - _vm.columns.length) && _vm.link) ? _c('button-link', {
      staticClass: "grid__link",
      attrs: {
        "to": _vm.link.to,
        "type": "border"
      }
    }, [_vm._v("\n        " + _vm._s(_vm.link.label) + "\n      ")]) : _vm._e()], 2)
  }) : _vm._l((_vm.posts), function(post, index) {
    return _c('post-preview', {
      key: post,
      staticClass: "grid__item",
      style: (_vm.getDelay(index)),
      attrs: {
        "post": post,
        "params": _vm.params
      }
    })
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('menu', {
    staticClass: "menu",
    class: _vm.classes,
    style: (("height:" + _vm.height + "px;"))
  }, [_c('li', {
    staticClass: "menu__tray menu__tray--nodes"
  }, [_c('nav', {
    staticClass: "menu__nav"
  }, [_c('router-link', {
    staticClass: "menu__link",
    attrs: {
      "to": "/",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('menu-close')
      }
    }
  }, [_vm._v(_vm._s(_vm.homeNode.meta.label))]), _vm._v(" "), _vm._l((_vm.nodes), function(node) {
    return (!node.meta.hidden && node.meta.index) ? _c('router-link', {
      staticClass: "menu__link",
      attrs: {
        "to": node.path
      },
      nativeOn: {
        "click": function($event) {
          _vm.$emit('menu-close')
        }
      }
    }, [_vm._v(_vm._s(node.meta.label))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "menu__tray menu__tray--links"
  }, [_c('nav', {
    staticClass: "menu__nav"
  }, [_vm._l((_vm.links), function(link) {
    return _c('router-link', {
      staticClass: "menu__link",
      attrs: {
        "to": link.path
      },
      nativeOn: {
        "click": function($event) {
          _vm.$emit('menu-close')
        }
      }
    }, [_vm._v(_vm._s(link.label))])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "menu__link menu__link--cta",
    attrs: {
      "to": "/infolettre"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('menu-close')
      }
    }
  }, [_c('icon', {
    attrs: {
      "id": "newsletter"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Infolettre")])], 1)], 2)])])
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar",
    class: _vm.classes
  }, [(_vm.to) ? _c('router-link', {
    staticClass: "sidebar__link",
    attrs: {
      "to": _vm.to
    }
  }, [_c('span', {
    staticClass: "sidebar__label"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), (_vm.left) ? _c('div', {
    staticClass: "sidebar__social"
  }, [_c('h6', [_vm._v(_vm._s(_vm.social.label))]), _vm._v(" "), _c('ul', _vm._l((_vm.social.accounts), function(account) {
    return _c('li', {
      staticClass: "sidebar__account"
    }, [_c('a', {
      attrs: {
        "href": account.url,
        "target": "_blank"
      }
    }, [_c('icon', {
      attrs: {
        "id": account.icon
      }
    })], 1)])
  }))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "ecosystem",
    class: _vm.padded
  }, [_c('div', {
    staticClass: "background ecosystem__background"
  }, [_c('h3', {
    staticClass: "background__banner ecosystem__banner",
    class: _vm.classes
  }, [_vm._v(_vm._s(_vm.content.banner))]), _vm._v(" "), _c('background-vector', {
    staticClass: "ecosystem__vector",
    attrs: {
      "animated": true,
      "images": _vm.logos,
      "hide-images": _vm.hideLogos,
      "scale": _vm.background.scale,
      "viewbox": _vm.background.viewbox
    },
    on: {
      "vector-ready": function($event) {
        _vm.ready = true
      }
    }
  })], 1), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "ecosystem__cta",
    class: (_vm.hideLogos) ? 'ecosystem__cta--hidden' : ''
  }, [_c('router-link', {
    staticClass: "button button--border",
    attrs: {
      "to": "/ecosysteme/details"
    }
  }, [_c('svg', {
    staticClass: "button__border"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-border"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "button__label"
  }, [_vm._v(_vm._s(_vm.content.label))])])], 1) : _c('ul', {
    staticClass: "ecosystem__list",
    class: (_vm.hideLogos) ? 'ecosystem__list--hidden' : ''
  }, [_vm._l((_vm.content.logos), function(logo) {
    return _c('router-link', {
      staticClass: "ecosystem__logo",
      attrs: {
        "tag": "li",
        "to": ("/ecosysteme/" + (logo.path))
      }
    }, [_c('img', {
      attrs: {
        "src": logo.image.url,
        "alt": logo.image.alt
      }
    })])
  }), _vm._v(" "), _c('li', {
    staticClass: "ecosystem__logo ecosystem__cta"
  }, [_c('router-link', {
    staticClass: "button button--border",
    attrs: {
      "to": "/ecosysteme/details"
    }
  }, [_c('svg', {
    staticClass: "button__border"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-border"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "button__label"
  }, [_vm._v(_vm._s(_vm.content.label))])])], 1)], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "entity"
    }
  }, [(_vm.ready) ? _c('router-view', {
    attrs: {
      "details": _vm.details
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('header-nav', {
    attrs: {
      "modifier": "ecosystem"
    }
  }), _vm._v(" "), _c('footer-nav', {
    attrs: {
      "modifier": "ecosystem",
      "sidebars": _vm.sidebars
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "list",
    class: _vm.classes
  }, [_c('ul', {
    staticClass: "list__group"
  }, _vm._l((_vm.posts), function(post) {
    return (_vm.posts) ? _c('li', {
      staticClass: "list__item"
    }, [_c('router-link', {
      staticClass: "list__post",
      attrs: {
        "to": ("/blogue/" + (post.path))
      }
    }, [_c('div', {
      staticClass: "list__content"
    }, [_c('h5', {
      staticClass: "list__title"
    }, [_vm._v(_vm._s(post.title || ((post.fulltitle) ? post.fulltitle[0].content : ' ')))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/blogue/categorie/" + (post.category))
      }
    }, [_c('icon', {
      staticClass: "list__icon",
      class: ("list__icon--" + (post.category)),
      attrs: {
        "id": post.category
      }
    })], 1)], 1)], 1) : _vm._e()
  })), _vm._v(" "), _c('nav', {
    staticClass: "list__nav"
  }, [_c('button', {
    staticClass: "paging paging--prev",
    attrs: {
      "data-disabled": !_vm.prevPage
    },
    on: {
      "click": function($event) {
        _vm.page--
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "paging",
    attrs: {
      "data-disabled": !_vm.nextPage
    },
    on: {
      "click": function($event) {
        _vm.page++
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "calendar"
  }, [_c('div', {
    staticClass: "background"
  }, [_c('background-vector', {
    staticClass: "calendar__vector",
    attrs: {
      "alpha": 0.15,
      "scale": _vm.background.scale,
      "viewbox": _vm.background.viewbox,
      "rotate": 75
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "background__banner calendar__banner"
  }, [_vm._v(_vm._s(_vm.content.banner))])], 1), _vm._v(" "), _c('div', {
    staticClass: "calendar__content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('header-nav'), _vm._v(" "), _c('footer-nav', {
    attrs: {
      "sidebars": _vm.sidebars
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 512 199"
    }
  }, [_c('path', {
    attrs: {
      "d": "m349.13 3.79h40.82v191.41h-40.82z"
    }
  }), _c('path', {
    attrs: {
      "d": "m181.58 3.79h40.82v191.41h-40.82z"
    }
  }), _c('path', {
    attrs: {
      "d": "m425.01 99.5h-40.82l64.48-95.71h40.81z"
    }
  }), _c('path', {
    attrs: {
      "d": "m463.75 129.22h-40.81l45.21 65.99h40.82z"
    }
  }), _c('path', {
    attrs: {
      "d": "m326.42 72.57c0-37.83-30.95-68.78-68.78-68.78h-18.73v38.76h18.73c7.94 0 15.46 3.14 21.16 8.85 5.71 5.71 8.85 13.22 8.85 21.16 0 7.94-3.14 15.46-8.85 21.16-5.71 5.71-13.22 8.85-21.16 8.85h-18.73v38.76h18.73c37.83.01 68.78-30.94 68.78-68.76"
    }
  }), _c('path', {
    attrs: {
      "d": "m89.72 37.38c18.42 1.69 27.23 11.99 29.45 26.84h38.78c-3.95-43.46-38.7-57.9-68.23-60.14v33.3"
    }
  }), _c('path', {
    attrs: {
      "d": "m101.01 85.37l-22.78-4.61c-16.81-3.25-26.03-8.68-26.03-21.15 0-11.42 8.07-18.89 21.04-21.48v-34.08c-37.83 2.79-62.52 25.58-62.52 58.82 0 28.74 16 46.91 52.6 54.23l30.1 5.7c18.71 3.52 23.05 11.39 23.05 18.98 0 12.47-10.85 19.79-30.37 19.79-24.67 0-40.94-11.66-43.93-30.37h-39.05c3.26 41.21 36.34 64.8 80.81 64.8 44.2 0 73.21-23.32 73.21-58.57 0-30.91-20.88-44.47-56.13-52.06"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('newsletter-form', {
    staticClass: "newsletter--panel",
    attrs: {
      "content": _vm.content
    }
  }, [_c('p', {
    staticClass: "newsletter__message"
  }, [_vm._v(_vm._s(_vm.message))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "background__banner home__banner"
  }, [_vm._v("Info-"), _c('br'), _vm._v("lettre")])
}]}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    ref: "svg",
    staticClass: "vector",
    class: _vm.classes,
    attrs: {
      "viewBox": _vm.setViewbox()
    },
    on: {
      "mousemove": _vm.setOffset
    }
  }, [_c('g', {
    attrs: {
      "fill": "#0f2f59",
      "stroke": "none",
      "opacity": _vm.alpha ? _vm.alpha : 0.5,
      "transform": _vm.transforms
    }
  }, [_c('path', {
    attrs: {
      "opacity": _vm.opacity.a,
      "d": _vm.pathA
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.b,
      "d": _vm.pathB
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.c,
      "d": _vm.pathC
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.d,
      "d": _vm.pathD
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.e,
      "d": _vm.pathE
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.f,
      "d": _vm.pathF
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.g,
      "d": _vm.pathG
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.h,
      "d": _vm.pathH
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.i,
      "d": _vm.pathI
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.j,
      "d": _vm.pathJ
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.k,
      "d": _vm.pathK
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.l,
      "d": _vm.pathL
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "vector-images"
    }
  }, [(!_vm.hideImages && !_vm.mobileImages) ? _c('g', _vm._l((_vm.images), function(image) {
    return _c('image', {
      staticClass: "vector__image",
      attrs: {
        "width": "200",
        "height": "62",
        "x": "-100",
        "y": "-31",
        "opacity": _vm.opacity.image,
        "transform": ("translate(" + (_vm.points[image.key]) + ")"),
        "xlink:href": image.url
      },
      on: {
        "click": function($event) {
          _vm.routeImage(image.path)
        }
      }
    })
  })) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "preview preview--event",
    class: _vm.classes
  }, [_c('safe-link', {
    staticClass: "preview__link preview__link--event",
    attrs: {
      "url": _vm.evt.link
    }
  }, [(_vm.evt.image) ? _c('img', {
    staticClass: "preview__img",
    attrs: {
      "src": _vm.image,
      "alt": _vm.evt.image.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('hgroup', {
    staticClass: "preview__hgroup"
  }, [_c('h4', {
    staticClass: "preview__type",
    class: ("preview__type--" + (_vm.type.tag))
  }, [_vm._v(_vm._s(_vm.type.name))]), _vm._v(" "), _c('h3', {
    staticClass: "preview__event"
  }, [_vm._v(_vm._s(_vm.name))])])]), _vm._v(" "), _c('safe-link', {
    staticClass: "preview__content",
    attrs: {
      "url": _vm.evt.link
    }
  }, [_c('h5', {
    staticClass: "preview__date",
    domProps: {
      "innerHTML": _vm._s(_vm.date)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "preview__description"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('span', {
    staticClass: "preview__plus"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": ("#" + _vm.id)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "entity"
  }, [(_vm.content.image) ? _c('h2', {
    staticClass: "entity__title"
  }, [_c('img', {
    staticClass: "entity__title--image",
    attrs: {
      "src": _vm.content.image.url,
      "alt": _vm.content.image.alt
    }
  })]) : _c('h2', {
    staticClass: "entity__title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _c('div', {
    staticClass: "rte"
  }, _vm._l((_vm.content.details), function(item) {
    return _c(item.component, {
      tag: "component",
      attrs: {
        "item": item
      }
    })
  })), _vm._v(" "), (_vm.content.url) ? _c('a', {
    staticClass: "entity__link",
    attrs: {
      "href": _vm.content.url,
      "target": "_blank"
    }
  }, [_vm._v("voir le site "), _c('icon', {
    attrs: {
      "id": 'arrow'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "entity__close",
    attrs: {
      "to": "/ecosysteme",
      "tag": "button"
    }
  }, [_vm._v("×")])], 1)
},staticRenderFns: []}

/***/ }),
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 660 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 661 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_meta_tags__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_startup_scripts__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_vue_media_sync__ = __webpack_require__(239);











__WEBPACK_IMPORTED_MODULE_8__utils_startup_scripts__["a" /* default */].run();
__WEBPACK_IMPORTED_MODULE_6__components__["a" /* default */].register();

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_resource___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7__plugins_meta_tags__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9__plugins_vue_media_sync__["a" /* default */], {
  phone: 'max-width: 567px',
  tablet: 'min-width: 568px',
  mobile: 'max-width: 1024px',
  desktop: 'min-width: 1025px',
  monitor: 'min-width: 1600px'
});

new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
  }
}).$mount('#app');

/***/ })
]),[662]);


// WEBPACK FOOTER //
// static/js/app.js